import { Avatar, Box, Button, Grid2, MenuItem, Modal, Select, Table, TableBody, TableCell,Tab , TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography, Paper, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Alert, CircularProgress } from "@mui/material";
import React, { useEffect, useState,useMemo } from "react";
import TokenError from "../tokenError";
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import exportCSVIcon from '../../assets/icons/exportCsvBlack.svg';
import { CSVLink } from "react-csv";
import {makePostRequestToUrl} from '../commonFunc.jsx';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import greenTick from '../../assets/icons/greenTic.svg';
import redCross from '../../assets/icons/redCross.svg';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import routeMarker from '../../assets/images/routeMarker.svg';
import constants from '../../constant.js';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
import { DirectionsRenderer, GoogleMap, InfoWindow, Marker, Polyline, useJsApiLoader } from "@react-google-maps/api";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import altProfile from '../../assets/images/altProfile.png';
import LinearProgress from '@mui/material/LinearProgress';

const LIBRARIES = ["maps", "drawing", "places", "geometry"];

const ShuttleBooking = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [errorMessage, setErrorMessage] = useState('');
    const [bookingData, setBookingData] = useState([]);
    const [tripId, setTripId] = useState('');
    const [bookingIdFilter, setBookingIdFilter] = useState('');
    const [userPhoneFilter, setUserPhoneFilter] = useState('');
    const [userIdFilter, setUserIdFilter] = useState('');
    const [filteredRows, setFilteredRows] = useState([]);
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [cityFilterfortab4, setCityFilterfortab4] = useState(cities[0].city_id);
    const [cityFilterfortab2, setCityFilterfortab2] = useState(cities[0].city_id);
    const [cityFilterfortab3, setCityFilterfortab3] = useState(cities[0].city_id);
    const [dateFilter, setDateFilter] = useState(dayjs());
    const [endDateFilter, setEndDateFilter] = useState(dayjs());
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [paginatedData, setPaginatedData] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [openRouteModal, setOpenRouteModal] = useState(false);
    const [routeData, setRouteData] = useState([]);
    const [bookingId, setBookingId] = useState('');
    const [polylineVisible, setPolylineVisible] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [allData, setAllData] = useState([]);
    const [dateFilterTab2, setDateFilterTab2] = useState(dayjs());
    const [bookingRefundLogs, setBookingRefundLogs] = useState([]);
    const [paginatedDataTab2, setPaginatedDataTab2] = useState([]);
    const [pageTab2, setPageTab2] = useState(0);
    const [rowsPerPageTab2, setRowsPerPageTab2] = useState(10);
    const [filteredRowsTab2, setFilteredRowsTab2] = useState([]);
    const [orderTab2, setOrderTab2] = useState('asc');
    const [orderByTab2, setOrderByTab2] = useState('id');
    const [driverPhoneFilter, setDriverPhoneFilter] = useState('');
    const [vehicleNumberFilter, setVehicleNumberFilter] = useState('');
    const [userPhoneFilterTab2, setUserPhoneFilterTab2] = useState('');
    const [originalRefundLogs, setOriginalRefundLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rowsPerPageTab3, setRowsPerPageTab3] = useState(10);
    const [filteredRowsTab3, setFilteredRowsTab3] = useState([]);
    const [orderTab3, setOrderTab3] = useState('asc');
    const [orderByTab3, setOrderByTab3] = useState('id');
    const [pageTab3, setPageTab3] = useState(0);
    const [paginatedDataTab3, setPaginatedDataTab3] = useState([]);
    const [filteredRowsTab4, setFilteredRowsTab4] = useState([]);
    const [paginatedDataTab4, setPaginatedDataTab4] = useState([]);
    const [pageTab4, setPageTab4] = useState(0);
    const [rowsPerPageTab4, setRowsPerPageTab4] = useState(10);
    const [driverTrips, setDriverTrips] = useState([]);
    const [dateFilterTab3, setDateFilterTab3] = useState(() => {
        const saved = localStorage.getItem('shuttleBookingDateTab3');
        return saved ? dayjs(saved) : dayjs();
    });
    const [startdatetab4, setStartdatetab4] = useState(dayjs().subtract(7, 'day'));
    const [enddatetab4, setEnddatetab4] = useState(dayjs());
    const [startdatetab5, setStartdatetab5] = useState(dayjs().subtract(31, 'day'));
    const [enddatetab5, setEnddatetab5] = useState(dayjs());
    const [cityFilterfortab5, setCityFilterfortab5] = useState(cities[0].city_id);
    const [paginatedDataTab5, setPaginatedDataTab5] = useState([]);
    const [pageTab5, setPageTab5] = useState(0);
    const [rowsPerPageTab5, setRowsPerPageTab5] = useState(10);
    const [filteredRowsTab5, setFilteredRowsTab5] = useState([]);
    const [rescheduleData, setRescheduleData] = useState([]);
    const [routesDataTab1, setRoutesDataTab1] = useState([]);
    const [selectedRouteIdTab1, setSelectedRouteIdTab1] = useState('');

    const [routesDataTab5, setRoutesDataTab5] = useState([]);
    const [vehicleDataTab5, setVehicleDataTab5] = useState([]);
    const [selectedRouteIdTab5, setSelectedRouteIdTab5] = useState('');
    const [selectedVehicleIdTab5, setSelectedVehicleIdTab5] = useState('');
    const [tripIdTab5, setTripIdTab5] = useState('');
    const [stopData, setStopData] = useState([]);
    const [startdatetab6, setStartdatetab6] = useState(dayjs().subtract(31, 'day'));
    const [enddatetab6, setEnddatetab6] = useState(dayjs());
    const [cityFilterfortab6, setCityFilterfortab6] = useState(cities[0].city_id);
    const [paginatedDataTab6, setPaginatedDataTab6] = useState([]);
    const [pageTab6, setPageTab6] = useState(0);
    const [rowsPerPageTab6, setRowsPerPageTab6] = useState(10);
    const [data,setdata] = useState({});
    const [shuttlePassData, setShuttlePassData] = useState([]);
    const [passSummary, setPassSummary] = useState([]);
    const [routeMapping, setRouteMapping] = useState([]);
    // const [tripIdTab6, setTripIdTab6] = useState('');
    const [passIdTab6, setPassIdTab6] = useState('');
    const [routeIdTab6, setrouteIdTab6] = useState('');
    const [openRefundModal, setOpenRefundModal] = useState(false);
    const [selectedRefundBooking, setSelectedRefundBooking] = useState(null);
    const [refundReason, setRefundReason] = useState('');
    const [refundSubmitting, setRefundSubmitting] = useState(false);
    const [refundError, setRefundError] = useState('');


    const navigate = useNavigate();
    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';
    const clientdataShown = localStorage.getItem('hideuserinfo');
    const driverDataShown = localStorage.getItem('hidedriverinfo');
    let shuttle_analytics_reports = [];
    const allowedTabsStr = JSON.parse(localStorage.getItem('clientRoleTabs')) || " ";
    const allowedTabs = allowedTabsStr?.split(',').map(Number);
    const SidebarTabs = constants.SidebarTabs;
    const hasPermission = (tabId) => allowedTabs.includes(tabId);
    const clientRole = localStorage.getItem('clientRole');

    try {
        const stored = localStorage.getItem('clientTabPermission');
        if (stored && stored !== 'undefined') {
            shuttle_analytics_reports = JSON.parse(stored);
        }
        if (!Array.isArray(shuttle_analytics_reports)) {
            shuttle_analytics_reports = [];
        }
    } catch (error) {
        console.error("Error parsing clientTabPermission from localStorage:", error);
        shuttle_analytics_reports = [];
    }
    const AnalyticsTab = shuttle_analytics_reports.find(p => p.tab_id === 25);

    // Helper function to handle both array and string formats
    const getShuttleAnalytics = (analytics) => {
        if (!analytics) return [];
        if (Array.isArray(analytics)) return analytics.map(item => String(item).trim());
        if (typeof analytics === 'string') return analytics.split(',').map(item => item.trim());
        return [];
    };

    const shuttleAnalyticsArray = getShuttleAnalytics(AnalyticsTab?.shuttle_analytics_reports);
    
    const hasPermission1 = shuttleAnalyticsArray.includes("1");
    const hasPermission2 = shuttleAnalyticsArray.includes("2");
    const hasPermission3 = shuttleAnalyticsArray.includes("3");
    const hasPermission4 = shuttleAnalyticsArray.includes("4");
    const hasPermission5 = shuttleAnalyticsArray.includes("5");
    const hasPermission6 = shuttleAnalyticsArray.includes("6");


    const { isLoaded, loadError } = useGoogleMapsLoader();
    const [map, setMap] = useState(null)
    const containerStyle = {
        width: '100%',
        height: '500px',
        };
    // const center = {
    //     lat: 28.644800, lng: 77.216721
    // };
    const center = {
        lat: routeData && routeData.length > 0
            ? routeData.reduce((sum, point) => sum + parseFloat(point.latitude || 0), 0) / routeData.length
            : 0,
        lng: routeData && routeData.length > 0
            ? routeData.reduce((sum, point) => sum + parseFloat(point.longitude || 0), 0) / routeData.length
            : 0,
    };
    
    const onLoad = React.useCallback((map) => {
        console.log('Map loaded successfully');
        setMap(map); // Store the map instance
    }, []);
    
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, []);
    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        borderRadius:'8px'
    };

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
        setSelectedRouteIdTab1('');
    }
    const handleCityChangefortab4 = (e) =>{
        const cityfortab4 =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilterfortab4(e);
        setRescheduleData([]);
        setFilteredRowsTab4([]);
        setPaginatedDataTab4([]);

    }

    const handleCityChangefortab2 = (e) =>{
        setCityFilterfortab2(e);
        setFilteredRowsTab2([]);
        setPaginatedDataTab2([]);
    }
    const handleCityChangefortab3 = (e) =>{
        setCityFilterfortab3(e);
        setFilteredRowsTab3([]);
        setPaginatedDataTab3([]);
    }

    const handleCityChangefortab5 = (e) =>{
        const cityfortab5 =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilterfortab5(e);
        setStopData([]);
        setFilteredRowsTab5([]);
        setPaginatedDataTab5([]);
    }

    const handleCityChangefortab6 = (e) => {
        const cityfortab6 = cities.find((cityObj) => cityObj.city_id === e)
        setCityFilterfortab6(e);

        setShuttlePassData([]);
        setPassSummary([]);
        setRouteMapping([]);
        // setStopData([]);
        // setFilteredRowsTab6([]);
        setPaginatedDataTab6([]);
    }

    const handleInputChange = (e) => {
        setTripId(e.target.value);
    };

    const handleBookingIdChange = (e) => {
        setBookingIdFilter(e.target.value);
    };

    const handleUserPhoneChange = (e) => {
        setUserPhoneFilter(e.target.value);
    };
    const handleUserIdChange = (e) => {
        setUserIdFilter(e.target.value);
    };
    const handleDriverPhoneChange = (e) => {
        setDriverPhoneFilter(e.target.value);
    };
    const handleUserPhoneChangeTab2 = (e) => {
        setUserPhoneFilterTab2(e.target.value);
    };
    const handleVehicleNumberChange = (e) => {
        setVehicleNumberFilter(e.target.value);
    };

    const fetchBookingData = async () => {
        setLoading(true); // Always start loading
    
        try {
            const url = serverUrl + '/shuttle/fetch_booking_details';
            const timestamp = new Date().getTime();
    
            const body = {
                token: token,
                city_id: cityFilter,
                date: dateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
    
            const response = await makeGetRequestToUrl(url, body, {}, 10000); // 10s timeout
    
            if (response.flag === 200) {
                const bookingData = response.data || [];
    
                setBookingData(bookingData);
            } else if (response.flag === 102) {
                console.log('Token is expired. Please login again');
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
    
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            } else {
                console.log('Unexpected response flag:', response.flag);
                setBookingData([]); // clear data
            }
        } catch (error) {
            console.log('API error or timeout:', error);
            setBookingData([]); // handle timeout or server error as no data
        } finally {
            setLoading(false); // Always stop loading
        }
    };
    
    useEffect(() => {
        fetchBookingData();
    }, [cityFilter, dateFilter, endDateFilter]);

    const fetchBookingRefundLogs = async() => {
        try {
            const url = serverUrl + '/shuttle/payments/refund_requests';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                date: dateFilterTab2.format('YYYY-MM-DD'),
                city_id: cityFilterfortab2,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const bookingData = response.data;
                setFilteredRowsTab2(bookingData);
                setOriginalRefundLogs(bookingData);

                const formattedData = formatDataForCSVTab2(bookingData);
                setBookingRefundLogs(formattedData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    useEffect(() => {
        fetchBookingRefundLogs();
    }, [dateFilterTab2, cityFilterfortab2]);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Get available tabs based on permissions
    const availableTabs = [];
    if (hasPermission1) availableTabs.push('1');
    if (hasPermission2) availableTabs.push('2');
    if (hasPermission3) availableTabs.push('3');
    if (hasPermission4) availableTabs.push('4');
    if (hasPermission5) availableTabs.push('5');
    if (hasPermission6) availableTabs.push('6');

    // Persist active tab so it is retained on navigation back from details
    const [value, setValue] = React.useState(() => {
        const savedTab = localStorage.getItem('shuttleBookingActiveTab');
        
        // If no tabs are available, return fallback
        if (availableTabs.length === 0) {
            return 'fallback'; // Special fallback value
        }
        
        // Use saved tab if it's available, otherwise use first available tab
        return savedTab && availableTabs.includes(savedTab) ? savedTab : availableTabs[0];
    });
    useEffect(() => {
        localStorage.setItem('shuttleBookingActiveTab', value);
        if(value==2){
            fetchBookingRefundLogs();
        }
    }, [value])

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...filteredRows].sort((a, b) => {
        if (a[property] < b[property]) return isAscending ? -1 : 1;
        if (a[property] > b[property]) return isAscending ? 1 : -1;
        return 0;
        });
        // setRows(sortedRows);
        setFilteredRows(sortedRows);
    };

    const handleRequestSortTab2 = (property) => {
        const isAscending = orderByTab2 === property && orderTab2 === 'asc';
        setOrderTab2(isAscending ? 'desc' : 'asc');
        setOrderByTab2(property);
        const sortedRows = [...filteredRowsTab2].sort((a, b) => {
        if (a[property] < b[property]) return isAscending ? -1 : 1;
        if (a[property] > b[property]) return isAscending ? 1 : -1;
        return 0;
        });
        // setRows(sortedRows);
        setFilteredRowsTab2(sortedRows);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangePagefortab4 = (event, newPage) => {
        setPageTab4(newPage);
    };
    useEffect(() => {
        const paginated = Array.isArray(filteredRows)
            ? filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [filteredRows, page, rowsPerPage]);

    const handleChangePageTab2 = (event, newPage) => {
        setPageTab2(newPage);
    };

    useEffect(() => {
        const paginated = Array.isArray(filteredRowsTab2)
            ? filteredRowsTab2.slice(pageTab2 * rowsPerPageTab2, pageTab2 * rowsPerPageTab2 + rowsPerPageTab2)
            : [];
        setPaginatedDataTab2(paginated);
    }, [filteredRowsTab2, pageTab2, rowsPerPageTab2]);

    useEffect(() => {
        const status = parseInt(statusFilter, 10);
    
        const filtered = bookingData.map((item) => {
            const maskedItem = { ...item };
            if (clientdataShown != 0 && item.phone_number) {
                const phone = item.phone_number;
                const cleanPhone = phone.replace(/\D/g, '');
                if (cleanPhone.length <= 4) {
                    maskedItem.phone_number = '****';
                } else {
                    const firstTwo = cleanPhone.substring(0, 2);
                    const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                    const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                    maskedItem.phone_number = "+" + firstTwo + maskedMiddle + lastTwo;
                }
            }
            if (driverDataShown != 0 && item.driver_phone_number) {
                const phone = item.driver_phone_number;
                const cleanPhone = phone.replace(/\D/g, '');
                if (cleanPhone.length <= 4) {
                    maskedItem.driver_phone_number = '****';
                } else {
                    const firstTwo = cleanPhone.substring(0, 2);
                    const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                    const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                    maskedItem.driver_phone_number = "+" + firstTwo + maskedMiddle + lastTwo;
                }
            }
            return maskedItem;
        }).filter((item) => {
            const matchesTripId = tripId ? item.trip_id?.toString().includes(tripId) : true;
            const matchesBookingId = bookingIdFilter ? item.booking_id?.toString().includes(bookingIdFilter) : true;
            const matchesUserId = userIdFilter
                ? item.user_id?.toString().includes(userIdFilter)
                : true;
            const matchesPhone = userPhoneFilter ? item.phone_number?.toString().includes(userPhoneFilter) : true;
            const matchesStatus = !isNaN(status) ? item.status === status : true;
            const matchesVehicleNumber = vehicleNumberFilter 
                ? item.vehicle_number?.toString().toUpperCase().includes(vehicleNumberFilter.toUpperCase()) 
                : true;
            const matchesDriverPhone = driverPhoneFilter ? item.driver_phone_number?.toString().includes(driverPhoneFilter) : true;
            const matchesRoute = selectedRouteIdTab1 ? item.route_id === selectedRouteIdTab1 : true;
            return matchesTripId && matchesBookingId && matchesUserId && matchesPhone && matchesStatus && matchesVehicleNumber && matchesDriverPhone && matchesRoute;
        });
        console.log('Filtered data:', filtered);
        const formattedData = formatDataForCSV(filtered);
        setAllData(formattedData);
        setFilteredRows(filtered);
        setPage(0);
    }, [tripId, bookingIdFilter, userIdFilter, userPhoneFilter, statusFilter, bookingData, vehicleNumberFilter, driverPhoneFilter, selectedRouteIdTab1]);
 
    useEffect(() => {
        const filtered = originalRefundLogs.filter((item) => {
            const matchesPhone = userPhoneFilterTab2 ? item.phone_number?.toString().includes(userPhoneFilterTab2) : true;
            return matchesPhone;
        });
        
        setFilteredRowsTab2(filtered);
        
        // Format filtered data for CSV
        const formattedDataTab2 = formatDataForCSVTab2(filtered);
        setBookingRefundLogs(formattedDataTab2);
        
        setPageTab2(0);
    }, [userPhoneFilterTab2, bookingRefundLogs]);
 

    const fetchRouteDetailsFromBookingId = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_booking_route';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                booking_id: bookingId,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const routeData = response.data;
                setRouteData(routeData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        if(bookingId) fetchRouteDetailsFromBookingId();
    }, [bookingId]);
    
    const viewRoute = (data) => {
        console.log('data==', data);
        setBookingId(data.booking_id); // Only set bookingId
        if(bookingId) fetchRouteDetailsFromBookingId();
    };

    useEffect(() => {
        if (routeData.length > 0) {
            setOpenRouteModal(true); // Now modal opens after data is ready
        }
    }, [routeData]);
    
    const handleClose = () => setOpenRouteModal(false);

    useEffect(() => {
        if (routeData.length > 0 && map) {
    
            const bounds = new window.google.maps.LatLngBounds();
            routeData.forEach((stop) => {
                if (stop.latitude && stop.longitude) {
                    bounds.extend(new window.google.maps.LatLng(Number(stop.latitude), Number(stop.longitude)));
                }
            });
    
            map.fitBounds(bounds); // Ensure all stops are visible
    
            // Force polyline to update
            setPolylineVisible(false);
            setTimeout(() => {
                setPolylineVisible(true);
            }, 50);
        }
    }, [routeData, map]);

    const formatDataForCSV = (data) => {
        return data ? (data.map((item) => ({
            ...item,
            payment_status: item.payment_status == 0 ? "Pending" : item.payment_status == 1 ? "Paid" : "Failed",
            status: item.status == 1 ? "Booked" : item.status == 2 ? "Cancelled" : item.status == 3 ? "Onboarded" : item.status == 6 ? "Ended" : item.status == 7 ? "Missed" : "",
            trip_date: item.trip_date ? item.trip_date.split("T")[0] : '',
            session_status: (item.session_status == 0 || item.session_status == null) ? "Not Started" : item.session_status == 1 ? "Started" : item.session_status == 2 ? "Ended" : "--",
            pickup_time: item.pickup_time ? dayjs(item.pickup_time).format('YYYY-MM-DD HH:mm:ss') : '',
            drop_time: item.drop_time ? dayjs(item.drop_time).format('YYYY-MM-DD HH:mm:ss') : '',
            booked_at: item.booked_at ? dayjs(item.booked_at).format('YYYY-MM-DD HH:mm:ss') : '',
            fare: (item.fare)*item.ticket_count,
        }))) : '';
    };

    const headers = [
        { label: 'Booking Id', key: 'booking_id' },
        { label: 'Trip ID', key: 'trip_id' },
        { label: 'User ID', key: 'user_id'},
        { label: 'User Name', key: 'user_name' },
        { label: 'Phone Number', key: 'phone_number' },
        { label: 'Driver Name', key: 'driver_name' },
        { label: 'Driver Phone Number', key: 'driver_phone_number' },
        { label: 'Vehicle Number', key: 'vehicle_number' },
        { label: 'Trip Status', key: 'session_status' },
        { label: 'Pickup Point', key: 'pickup_address' },
        { label: 'Drop Point', key: 'drop_address' },
        { label: 'Pickup Time', key: 'pickup_time' },
        { label: 'Drop Time', key: 'drop_time' },
        { label: 'Booking Time', key: 'booked_at' },
        { label: 'Trip Date', key: 'trip_date' },
        { label: 'Trip Time', key: 'time' },
        { label: 'Total Seats', key: 'ticket_count' },
        { label: 'Seat Numbers', key: 'seat_numbers' },
        { label: 'Amount', key: 'fare' },
        { label: 'Paid using wallet', key: 'paid_using_wallet' },
        { label: 'Paid using Razorpay', key: 'paid_using_razorpay' },
        { label: 'Promo', key: 'promo_title' },
        { label: 'Discounted Fare', key: 'discounted_fare' },
        { 
            label: 'Payment Status', 
            key: 'payment_status',
            formatter: (value) => value == 0 ? "Pending" : value == 1 ? "Paid" : "Failed"
        },
        { 
            label: 'Booking Status', 
            key: 'status',
            formatter: (value) => value == 1 ? "Booked" : value == 2 ? "Cancelled" : value == 3 ? "Onboarded" : value == 6 ? "Ended" : value == 7 ? "Missed" : ""
        },
        { label: 'Refund Amount', key: 'refund_amount' },
        { label: 'Refund Percentage', key: 'refund_percentage' },
        { label: 'Cancellation Reason', key: 'cancellation_reason' },
        { label: 'Cancel Time Description', key: 'time_description' }
    ];

    const headersTab2 = [
        { label: 'ID', key: 'id' },
        { label: 'Requested Seats', key: 'requested_seats' },
        { label: 'Seat booked by booking ID', key: 'seat_booked_by_booking_id' },
        { label: 'Request time', key: 'request_time' },
        { label: 'User Name', key: 'user_name' },
        { label: 'Phone Number', key: 'phone_number' },
    ];

    const formatDataForCSVTab2 = (data) => {
        return data ? (data.map((item) => ({
            ...item,
            request_time: item.request_time ? dayjs(item.request_time).format('YYYY-MM-DD HH:mm:ss') : '',
        }))) : '';
    };

    const handleViewTripDetails = (sessionId) => {
        console.log('sessionId-1', sessionId);
        console.log('dateFilterTab3-1', dateFilterTab3);
        navigate('/driver-trip-details', { state: { sessionId, dateFilterTab3: dateFilterTab3.format('YYYY-MM-DD') } });
    }

    const fetchDriverTrips = async() => {
        try {
            const url = serverUrl + `/shuttle/fetch_active_sessions`;
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                date: dateFilterTab3.format('YYYY-MM-DD'),
                city_id: cityFilterfortab3,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const driverTrips = response.data;
                console.log('driverTrips', driverTrips);
                setDriverTrips(driverTrips);
                setFilteredRowsTab3(driverTrips);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchRescheduleDetails = async() => {
        try {
            const url = serverUrl + `/shuttle/reports/fetch_reschedule_report`;
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                start_date: startdatetab4.format('YYYY-MM-DD'),
                end_date: enddatetab4.format('YYYY-MM-DD'),
                city_id: cityFilterfortab4,
                
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const rescheduleData = response.data;
                console.log('rescheduleData', rescheduleData);
                setRescheduleData(rescheduleData);
                setFilteredRowsTab4(rescheduleData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

        const extractReschedules = (row) => {
        const res = [];
        for (let i = 1; i <= row.total_reschedules; i++) {
            const p = `R${i}`;
            res.push({
            prefix: p,
            prev_driver_id: row[`${p}_prev_driver_id`],
            new_driver_id: row[`${p}_new_driver_id`],

            prev_driver_name: row[`${p}_prev_driver_name`],
            new_driver_name: row[`${p}_new_driver_name`],

            prev_driver_phone_number: row[`${p}_prev_driver_phone_number`],
            new_driver_phone_number: row[`${p}_new_driver_phone_number`],

            prev_driver_image: row[`${p}_prev_driver_image`],
            new_driver_image: row[`${p}_new_driver_image`],

            prev_trip_id: row[`${p}_prev_trip_id`],
            new_trip_id: row[`${p}_new_trip_id`],

            prev_trip_date: row[`${p}_prev_trip_date`],
            new_trip_date: row[`${p}_new_trip_date`],

            prev_pickup_time: row[`${p}_prev_pickup_time`],
            new_pickup_time: row[`${p}_new_pickup_time`],

            prev_drop_time: row[`${p}_prev_drop_time`],
            new_drop_time: row[`${p}_new_drop_time`],

            prev_ticket_count: row[`${p}_prev_ticket_count`],
            new_ticket_count: row[`${p}_new_ticket_count`],

            prev_seat_numbers: row[`${p}_prev_seat_numbers`],
            new_seat_numbers: row[`${p}_new_seat_numbers`],

            prev_fare: row[`${p}_prev_fare`],
            new_fare: row[`${p}_new_fare`],

            prev_pickup_stop_name: row[`${p}_prev_pickup_stop_name`],
            new_pickup_stop_name: row[`${p}_new_pickup_stop_name`],

            prev_drop_stop_name: row[`${p}_prev_drop_stop_name`],
            new_drop_stop_name: row[`${p}_new_drop_stop_name`],
            });
        }
        return res;
        };

    const fetchStopDetails = async() => {
        try {
            const url = serverUrl + `/shuttle/reports/fetch_stops_bookings_report`;
            const body = {
                token: token,
                start_date: startdatetab5.format('YYYY-MM-DD'),
                end_date: enddatetab5.format('YYYY-MM-DD'),
                city_id: cityFilterfortab5,
            };
            if(selectedRouteIdTab5){
                body.route_id = selectedRouteIdTab5;
            }
            if(selectedVehicleIdTab5){
                body.vehicle_id = selectedVehicleIdTab5;
            }
            if(tripIdTab5.length>=2){
                body.trip_id = tripIdTab5;
            }
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const stopData = response.data;
                setStopData(stopData);
                setFilteredRowsTab5(stopData);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const fetchRoutesDetails = async() =>{
        try {
           const url = serverUrl + `/shuttle/fetch_routes`;
           const body = {
            token: token,
            city_id: cityFilterfortab5,
           }
           const response = await makeGetRequestToUrl(url, body);
           if(response.flag==200){
            const routesData = response.data;
            setRoutesDataTab1(routesData);
            setRoutesDataTab5(routesData);
           }
            
        } catch (error) {
            
        }
    }
    const fetchVehiclDetails = async() =>{
        try {
           const url = serverUrl + `/vehicle/fetch_vehicle_make`;
           const body = {
            token: token,
            city_id: cityFilterfortab5,
           }
           const response = await makeGetRequestToUrl(url, body);
           if(response.flag==200){
            const vehicleData = response.data;
            setVehicleDataTab5(vehicleData);
           }
            
        } catch (error) {
            
        }
    }

    

    useEffect(() => {
        fetchRoutesDetails();
        fetchVehiclDetails();
    }, [cityFilterfortab5]);


    const fetchShuttlePassData = async () => {
        setLoading(true); // Always start loading
    
        try {
            const url = serverUrl + '/shuttle/reports/fetch_shuttle_pass_report';
            const timestamp = new Date().getTime();
    
            const body = {
                token: token,
                city_id: cityFilterfortab6,
                start_date: startdatetab6.format('YYYY-MM-DD'),
                end_date: enddatetab6.format('YYYY-MM-DD'),
                timestamp: timestamp
            };
    
            const response = await makeGetRequestToUrl(url, body, {}, 10000); // 10s timeout
    
            if (response.flag === 200) {
                const shuttlepass= response.data || [];
                setdata(shuttlepass);
                setShuttlePassData(shuttlepass.pass_summary);
                setPassSummary(response.data.pass_summary);
                setRouteMapping(response.data.route_mapping);

            } else if (response.flag === 102) {
                console.log('Token is expired. Please login again');
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
    
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            } else {
                console.log('Unexpected response flag:', response.flag);
                setShuttlePassData([]); // clear data
            }
        } catch (error) {
            console.log('API error or timeout:', error);
            setShuttlePassData([]); // handle timeout or server error as no data
        } finally {
            setLoading(false); // Always stop loading
        }
    };

     useEffect(() => {
        if(value == 6){
            fetchShuttlePassData();
        }
    }, [cityFilterfortab6,startdatetab6,enddatetab6,value])

    // const filteredRowsTab6 = useMemo(() => {
    // return tableData.filter((pass) => {

    //     if (passIdTab6 && String(pass.pass_id) !== String(passIdTab6)) {
    //     return false;
    //     }

    //     if (routeIdTab6) {
    //     const routeExists = routeMapping.some(
    //         (rm) =>
    //         String(rm.pass_id) === String(pass.pass_id) &&
    //         String(rm.route_id).includes(String(routeIdTab6))
    //     );

    //     if (!routeExists) return false;
    //     }

    //     return true;
    // });
    // }, [passSummary, routeMapping, passIdTab6, routeIdTab6]);

    const handleTripIdChange = (e) => {
        const value = e.target.value;
        setTripIdTab5(value);
    };

    // DELETE THIS
    useEffect(() => {
        if (value == 5) { fetchStopDetails(); }
    }, [startdatetab5, enddatetab5, cityFilterfortab5, value, selectedRouteIdTab5, selectedVehicleIdTab5]);

    // DELETE THIS TOO
    useEffect(() => {
        if (tripIdTab5.length >= 2 || tripIdTab5 === '') {
            fetchStopDetails();
        }
    }, [tripIdTab5]);

    const handleRouteChangeTab1 = (e) => {
        setSelectedRouteIdTab1(e.target.value);
    }

    const availableRouteIdsTab1 = useMemo(() => {
        return new Set(bookingData.map((item) => item.route_id));
    }, [bookingData]);

    const availableRoutesTab1 = useMemo(() => {
        return routesDataTab1.filter((route) => availableRouteIdsTab1.has(route.route_id));
    }, [routesDataTab1, availableRouteIdsTab1]);

    const handleRouteChangeTab5 = (e) => {
        setSelectedRouteIdTab5(e.target.value);
    }

    const handleVehicleChangeTab5 = (e) => {
        setSelectedVehicleIdTab5(e.target.value);
    }

    const headersTab3 = [
        { label: 'Session ID', key: 'session_id' },
        { label: 'Trip ID', key: 'trip_id' },
        { label: 'Driver ID', key: 'driver_id' },
        { label: 'Driver Name', key: 'driver_name' },
        { label: 'Phone Number', key: 'phone_number' },
        { label: 'Start Time', key: 'start_time' },
        { label: 'End Time', key: 'end_time' }
    ];
    const formatDataForCSVTab3 = (data) => {
        return data
        ? data.map((item) => {
            return {
                ...item,
                start_time: item.start_time
                ? (() => {
                    const pickupDate = new Date(item.start_time);
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: timeZoneFormat === '12',
                        timeZone: 'UTC',
                    }).replace(',', ' |');
                    })()
                : '--',
                end_time: item.end_time
                ? (() => {
                    const pickupDate = new Date(item.end_time);
                    pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                    return pickupDate.toLocaleString('en-GB', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: timeZoneFormat === '12',
                        timeZone: 'UTC',
                    }).replace(',', ' |');
                    })()
                : '--',
            };
            })
        : '';
    };
    const handleRequestSortTab3 = (property) => {
        const isAscending = orderByTab3 === property && orderTab3 === 'asc';
        setOrderTab3(isAscending ? 'desc' : 'asc');
        setOrderByTab3(property);
            const sortedRows = [...filteredRowsTab3].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        // setRows(sortedRows);
        setFilteredRowsTab3(sortedRows);
    };

    // First, create a function to generate table data with multiple rows per pass
const generateTableData = () => {
    const result = [];
    
    data.pass_summary?.forEach(pass => {
        const relatedRoutes = data.route_mapping?.filter(r => r.pass_id === pass.pass_id) || [];
        
        if (relatedRoutes.length === 0) {
            // If no routes, create one row with pass data only
            result.push({
                ...pass,
                route_id: "--",
                route_name: "--"
            });
        } else {
            // Create separate rows for each route
            relatedRoutes.forEach(route => {
                result.push({
                    ...pass,
                    route_id: route.route_id,
                    route_name: route.route_name
                });
            });
        }
    });
    
    return result;
};

const tableData = useMemo(() => generateTableData(), [data.pass_summary, data.route_mapping]);

const filteredRowsTab6 = useMemo(() => {
    return tableData.filter((row) => {
        if (passIdTab6) {
            if (!String(row.pass_id).includes(String(passIdTab6))) {
                return false;
            }
        }
 
        if (routeIdTab6) {
            if (!String(row.route_id).includes(String(routeIdTab6))) {
                return false;
            }
        }
 
        return true;
    });
}, [tableData, passIdTab6, routeIdTab6]);
useEffect(() => {
    setPageTab6(0);
}, [passIdTab6, routeIdTab6]);

    useEffect(() => {
        const paginated = Array.isArray(filteredRowsTab3)
            ? filteredRowsTab3.slice(pageTab3 * rowsPerPageTab3, pageTab3 * rowsPerPageTab3 + rowsPerPageTab3)
            : [];
        setPaginatedDataTab3(paginated);
    }, [filteredRowsTab3, pageTab3, rowsPerPageTab3]);

    useEffect(() => {
        const paginated = Array.isArray(filteredRowsTab5)
            ? filteredRowsTab5.slice(pageTab5 * rowsPerPageTab5, pageTab5 * rowsPerPageTab5 + rowsPerPageTab5)
            : [];
        setPaginatedDataTab5(paginated);
    }, [filteredRowsTab5, pageTab5, rowsPerPageTab5]);

    useEffect(() => {
        const paginated = Array.isArray(filteredRowsTab6)
            ? filteredRowsTab6.slice(pageTab6 * rowsPerPageTab6, pageTab6 * rowsPerPageTab6 + rowsPerPageTab6)
            : [];
        setPaginatedDataTab6(paginated);
    }, [filteredRowsTab6, pageTab6, rowsPerPageTab6]);

    useEffect(() => {
        if(value==3){
            fetchDriverTrips();
        }
    }, [value, dateFilterTab3, cityFilterfortab3])

    // Persist tab 3 date filter so it remains the same when returning from details
    useEffect(() => {
        if (dateFilterTab3) {
            localStorage.setItem('shuttleBookingDateTab3', dayjs(dateFilterTab3).format('YYYY-MM-DD'));
        }
    }, [dateFilterTab3]);

        useEffect(() => {
        const paginated = Array.isArray(filteredRowsTab4)
            ? filteredRowsTab4.slice(pageTab4 * rowsPerPageTab4, pageTab4 * rowsPerPageTab4 + rowsPerPageTab4)
            : [];
        setPaginatedDataTab4(paginated);
    }, [filteredRowsTab4, pageTab4, rowsPerPageTab4,cityFilterfortab4]);

    useEffect(() => {
        const filtered = rescheduleData.filter((item) => {
            const matchesBookingId = bookingIdFilter ? item.booking_id?.toString().includes(bookingIdFilter) : true;
            return matchesBookingId;
        });
        
        setFilteredRowsTab4(filtered);
        setPageTab4(0);
    }, [bookingIdFilter, rescheduleData]);

        useEffect(() => {
        if(value==4){
            fetchRescheduleDetails();
        }
    }, [value, startdatetab4, enddatetab4,cityFilterfortab4])

    // useEffect(() => {
    //     if(value==5){
    //         fetchStopDetails();
    //     }
    // }, [value, startdatetab5, enddatetab5,cityFilterfortab5])

    
    const handleChangePageTab3 = (event, newPage) => {
        setPageTab3(newPage);
    };

    const handleChangePageTab5 = (event, newPage) => {
        setPageTab5(newPage);
    };
    const handleChangePageTab6 = (event, newPage) => {
        setPageTab6(newPage);
    };
    
    const handleOpenRefundModal = (row) => {
        setSelectedRefundBooking(row);
        setRefundReason('');
        setRefundError('');
        setOpenRefundModal(true);
    };
    
    const handleCloseRefundModal = () => {
        if (refundSubmitting) return; // prevent closing mid-request
        setOpenRefundModal(false);
        setSelectedRefundBooking(null);
    };

    const handleConfirmRefund = async () => {
        if (!selectedRefundBooking?.booking_id) return;
    
        const trimmedReason = refundReason.trim();
        if (!trimmedReason) {
            setRefundError('Please enter a reason for the refund.');
            return;
        }
        setRefundSubmitting(true);
        setRefundError('');
        try {
            const url = operationsUrl + '/shuttle/admin/razorpay_refund';
            const body = {
                token: token,
                booking_id: selectedRefundBooking.booking_id,
                reason: trimmedReason,
            };
    
            const response = await makePostRequestToUrl(url, body);
    
            if (response.flag == 200) {
                setOpenRefundModal(false);
                setSelectedRefundBooking(null);
                fetchBookingData(); // refresh table so refund details update
            } else if (response.flag == 102) {
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => navigate('/signup'), 2000);
            } else {
                setRefundError(response.message || 'Refund could not be processed. Please try again.');
            }
        } catch (error) {
            console.log('refund error', error);
            setRefundError('Something went wrong while processing the refund.');
        } finally {
            setRefundSubmitting(false);
        }
    };


    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Analytics</Typography>

            {availableTabs.length === 0 ? (
                <Paper elevation={2} style={{padding:'2%', marginTop:'2%', textAlign:'center',borderRadius:'12px'}}>
                    <Typography variant="h6" sx={{ color: '#666', mb: 2 }}>
                        No Analytics Permissions Available
                    </Typography>
                    <Typography sx={{ color: '#999' }}>
                        You don't have permission to access any shuttle analytics modules. 
                        Please contact your administrator to get the required permissions.
                    </Typography>
                </Paper>
            ) : (
                <TabContext value={value} onChange={handleChange} style={{marginTop:'12%'}}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider',}}>
                    <TabList 
                        onChange={handleChange} 
                        variant="scrollable"
                        scrollButtons={false}
                        allowScrollButtonsMobile
                        aria-label="shuttle booking tabs" 
                        sx={{
                            backgroundColor: '#2A313C', 
                            borderRadius: '12px 12px 0 0',
                            marginTop: '12px',
                            minHeight: '60px',
                            textAlign: 'center',
                            '& .MuiTabs-flexContainer': {
                                height: '60px',
                                alignItems: 'center',
                            },
                            '& .MuiTabs-indicator': {
                                backgroundColor: '#1976d2',
                                height: '3px'
                            },
                        }}
                    >
                        {hasPermission1 && <Tab 
                            label="Booking" 
                            value="1" 
                            sx={{
                                color: 'grey.400',
                                textTransform:'none',
                                minWidth:'200px',
                                '&.Mui-selected': {
                                    color: 'white',
                                    fontWeight: 600,
                                },
                                '&:hover': {
                                    color: 'white',
                                    opacity: 0.8,
                                },
                            }}
                        />}
                        {hasPermission2 && <Tab 
                            label="Booking Refund Logs" 
                            value="2"
                            sx={{
                                color: 'grey.400',
                                textTransform:'none',
                                minWidth:'200px',
                                '&.Mui-selected': {
                                    color: 'white',
                                    fontWeight: 600,
                                },
                                '&:hover': {
                                    color: 'white',
                                    opacity: 0.8,
                                },
                            }}
                        />}
                        {hasPermission3 && <Tab 
                            label="Driver Trips" 
                            value="3"
                            sx={{
                                color: 'grey.400',
                                textTransform:'none',
                                minWidth:'200px',
                                '&.Mui-selected': {
                                    color: 'white',
                                    fontWeight: 600,
                                },
                                '&:hover': {
                                    color: 'white',
                                    opacity: 0.8,
                                },
                            }}
                        />}
                        {hasPermission4 && <Tab 
                            label="Shuttle Reshedule Report" 
                            value="4"
                            sx={{
                                color: 'grey.400',
                                textTransform:'none',
                                minWidth:'200px',
                                '&.Mui-selected': {
                                    color: 'white',
                                    fontWeight: 600,
                                },
                                '&:hover': {
                                    color: 'white',
                                    opacity: 0.8,
                                },
                            }}
                        />}
                        {hasPermission5 && <Tab 
                            label="Stop Utilization Report" 
                            value="5"
                            sx={{
                                color: 'grey.400',
                                textTransform:'none',
                                minWidth:'200px',
                                '&.Mui-selected': {
                                    color: 'white',
                                    fontWeight: 600,
                                },
                                '&:hover': {
                                    color: 'white',
                                    opacity: 0.8,
                                },
                            }}
                        /> }
                        {hasPermission6 && <Tab 
                            label="Shuttle Pass Report" 
                            value="6"
                            sx={{
                                color: 'grey.400',
                                textTransform:'none',
                                minWidth:'200px',
                                '&.Mui-selected': {
                                    color: 'white',
                                    fontWeight: 600,
                                },
                                '&:hover': {
                                    color: 'white',
                                    opacity: 0.8,
                                },
                            }}
                        />}
                    </TabList>
                </Box>

                <TabPanel value="1" style={{padding:' 0% 0%'}}>
                    <Paper elevation={2} style={{padding:'2%'}}>
                        <Grid2 item container spacing={2}>
                            <Grid2 item>
                                <Select value={cityFilter} 
                                onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                                style={{width: '140px',height:'48px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                    {clientRole == 1 && <MenuItem value="">Select City</MenuItem>}
                                    {cities.map((city) => (
                                        <MenuItem key={city.city_name} value={city.city_id}>
                                            {city.city_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>
                            <Grid2 item xs="auto">
                                <Select value={selectedRouteIdTab1} 
                                    onChange={(e) => handleRouteChangeTab1(e)} displayEmpty
                                    style={{width: '240px',height:'48px',borderRadius:'8px'}}>
                                        <MenuItem value="">Select Route</MenuItem>
                                        {availableRoutesTab1.map((route) => (
                                            <MenuItem key={route.route_name} value={route.route_id}>
                                                {route.route_name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </Grid2>

                            {/* <Grid2 item>
                                <Button
                                    variant="contained"
                                    // onClick={handleOpenAddModal}
                                    style={{width:'190px', height:'50px', backgroundColor:'#000000', textTransform:'none', borderRadius:'8px'}}>
                                    + Add Booking
                                </Button>
                            </Grid2> */}
                            <Grid2 xs="auto" sx={{width:'120px', height:'50px'}}>
                                <input type="number" placeholder="Trip Id" className='filterBtn' value={tripId} onChange={handleInputChange} style={{ width: '100%' }} min="0"
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                    e.preventDefault();
                                    }
                                }} />
                            </Grid2>

                            <Grid2 xs="auto" sx={{ width: '120px', height:'50px' }}>
                                <input type="number" placeholder="Booking Id" className="filterBtn" value={bookingIdFilter} onChange={handleBookingIdChange} style={{ width: '100%' }} min="0"
                                    onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                        e.preventDefault();
                                    }
                                    }}
                                />
                            </Grid2>
                            <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="number" 
                                    placeholder="User Id" 
                                    className="filterBtn"
                                    value={userIdFilter} 
                                    onChange={handleUserIdChange}
                                    style={{ width: '100%' }}
                                />
                            </Grid2>
                            <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="number" 
                                    placeholder="User Phone Number" 
                                    className="filterBtn"
                                    value={userPhoneFilter} 
                                    onChange={handleUserPhoneChange}
                                    style={{ width: '100%' }}
                                />
                            </Grid2>
                            <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="number" 
                                    placeholder="Driver Phone Number" 
                                    className="filterBtn"
                                    value={driverPhoneFilter} 
                                    onChange={handleDriverPhoneChange}
                                    style={{ width: '100%' }}
                                />
                            </Grid2>
                            <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="text" 
                                    placeholder="Vehicle Number" 
                                    className="filterBtn"
                                    value={vehicleNumberFilter} 
                                    onChange={handleVehicleNumberChange}
                                    style={{ width: '100%' }}
                                />
                            </Grid2>

                            <Grid2 item xs="auto">
                                <Select value={statusFilter} 
                                    onChange={(e) => setStatusFilter(e.target.value)} displayEmpty
                                    style={{width: '140px',height:'48px',borderRadius:'8px'}}>
                                        <MenuItem value="">All</MenuItem>
                                        <MenuItem value="1">Booked</MenuItem>
                                        <MenuItem value="2">Cancelled</MenuItem>
                                        <MenuItem value="3">Onboarded</MenuItem>
                                        <MenuItem value="6">Ended</MenuItem>
                                        <MenuItem value="7">Missed</MenuItem>
                                </Select>
                            </Grid2>


                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                        '& .MuiInputBase-root': {
                                        height: '50px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        }
                                    }}
                                    value={dateFilter}
                                    onChange={(newValue) => setDateFilter(newValue)}
                                    minDate={endDateFilter.subtract(31, 'day')}
                                    maxDate={endDateFilter}
                                    />
                                </LocalizationProvider>
                            </Grid2>

                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                        '& .MuiInputBase-root': {
                                        height: '50px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        }
                                    }}
                                    value={endDateFilter}
                                    onChange={(newValue) => {
                                        const daysDiff = newValue.diff(dateFilter, 'days');
                                    
                                        setEndDateFilter(newValue);
                                    
                                        if (daysDiff > 31) {
                                            setDateFilter(newValue.clone().subtract(31, 'days'));
                                        }
                                    }}
                                    minDate={dateFilter}
                                    />
                                </LocalizationProvider>
                            </Grid2>

                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button variant='contained' style={{width: '120px', height: '48px', backgroundColor:'#36C68F', textTransform:'none', borderRadius:'8px',marginLeft:'auto'}}> 
                                    <CSVLink
                                        data={allData}
                                        headers={headers}
                                        filename={"Booking Data.csv"}
                                        style={{ textDecoration: 'none' }} // Add this line to remove underline
                                    > 
                                        <Typography sx={{color: '#fff'}}>Export CSV</Typography>
                                    </CSVLink>
                                </Button>
                            </Grid2>

                        </Grid2>

                        <Modal open={openRouteModal} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                            <Box sx={style}>
                                <Typography id="modal-modal-title" variant="h6" component="h2">
                                    Booking ID : {bookingId}
                                </Typography>
                                <hr/>
                                <Grid2 id="modal-modal-description" sx={{ mt: 2 }}>
                                    <Grid2 item container>
                                        <Grid2 item sx={{display:'flex'}}>
                                            <img src={pickupMarker} alt="Pickup Point" />
                                            <Typography sx={{marginLeft:'4px'}}>Pickup Point</Typography>
                                        </Grid2>
                                        <Grid2 item sx={{display:'flex', marginLeft:'4%'}}>
                                            <img src={dropMarker} alt="Drop Point" />
                                            <Typography sx={{marginLeft:'4px'}}>Drop Point</Typography>
                                        </Grid2>
                                    </Grid2>

                                    <Grid2 className='mainBox' sx={{marginTop:'2%'}}>
                                        {isLoaded ? (
                                            <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={6} onLoad={onLoad} onUnmount={onUnmount}>
                                                {routeData && polylineVisible && routeData.map((stop, index) => {
                                                    // Determine which marker to use based on the conditions
                                                    let markerIcon;
                                                    if (stop.is_pickup_stop) {
                                                        markerIcon = {
                                                        url: pickupMarker,
                                                        scaledSize: new window.google.maps.Size(30, 30),
                                                        labelOrigin: new window.google.maps.Point(20, 14)
                                                        };
                                                    } else if (stop.is_drop_stop) {
                                                        markerIcon = {
                                                        url: dropMarker,  // Assuming you have a dropMarker image
                                                        scaledSize: new window.google.maps.Size(30, 30),
                                                        labelOrigin: new window.google.maps.Point(20, 14)
                                                        };
                                                    } 
                                                    else {
                                                        markerIcon = {
                                                        url: routeMarker,
                                                        scaledSize: new window.google.maps.Size(20, 20),
                                                        labelOrigin: new window.google.maps.Point(20, 14)
                                                        };
                                                    }

                                                    return (
                                                        <Marker 
                                                        key={index}
                                                        position={{ lat: Number(stop.latitude), lng: Number(stop.longitude) }}
                                                        // title={stop.route_id}
                                                        icon={markerIcon}
                                                        />
                                                    );
                                                })}

                                                {routeData && polylineVisible && routeData.length > 1 && (
                                                    <Polyline
                                                        path={routeData.map((stop) => ({
                                                        lat: Number(stop.latitude),
                                                        lng: Number(stop.longitude),
                                                        }))}
                                                        options={{
                                                        strokeColor: "#0065FF",
                                                        strokeOpacity: 1.0,
                                                        strokeWeight: 4,
                                                        }}
                                                    />
                                                )}

                                            </GoogleMap>
                                            
                                        ): (<></>)}
                                    </Grid2>
                                </Grid2>
                            </Box>
                        </Modal>

                        <TableContainer className="table-container" style={{maxHeight:'60vh'}}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Booking ID</TableCell> */}
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'booking_id'} direction={orderBy === 'booking_id' ? order : 'asc'}
                                                onClick={() => handleRequestSort('booking_id')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Booking ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '55%' }}>
                                            <Typography sx={{padding:'12px'}}>User</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Driver</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Vehicle Number</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Trip Status</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'trip_id'} direction={orderBy === 'trip_id' ? order : 'asc'}
                                                onClick={() => handleRequestSort('trip_id')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Trip ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Route</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Trip Date</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Trip Time</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Total Seats</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Seat Numbers</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Pickup Point</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Drop Point</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Pickup Time</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Drop Time</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Booking Time</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Amount</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Paid using wallet</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Paid using Razorpay</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Promo</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Discounted Fare</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Payments</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Status</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Cancellation Reason</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Refund Amount</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Refund Percentage</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Cancel Time</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <Typography sx={{padding:'12px'}}>Actions</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {loading ? (
                                        <TableRow>
                                            <TableCell colSpan={28} align="center">
                                                <LinearProgress />
                                            </TableCell>
                                        </TableRow>
                                    ) : 
                                    paginatedData.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={28} align="center">
                                                <Typography variant="body1">No data found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                    paginatedData.map((row) => {
                                        // const city = clientCities.find(city => city.city_id === row.city_id);
                                        // const cityName = city ? city.city_name : '---';

                                        // const registeredCity = clientCities.find(city => city.city_id === row.registered_city_id);
                                        // const registeredCityName = registeredCity ? registeredCity.city_name : '---';

                                        return(
                                            <TableRow key={row.id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.booking_id}</Typography></TableCell>
                                                <TableCell>
                                                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                        <Grid2>
                                                            {
                                                                row.user_image ? <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={row.user_name} src={row.user_image}></Avatar> :
                                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={row.user_name} src={altProfile}></Avatar>
                                                            }
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                            <Grid2><Typography sx={{ color: "#83888E", fontSize: "14px" }}>User Id : {row.user_id}</Typography></Grid2>
                                                            <Grid2><Typography>{row.user_name}</Typography></Grid2>
                                                            <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{clientdataShown == 0 ? row.phone_number : (() => {
                                                            if (!row.phone_number) return '****';
                                                            const phone = row.phone_number;
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}</Typography></Grid2>
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell>
                                                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                        <Grid2>
                                                            {
                                                                row.driver_image ? <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={row.driver_name} src={row.driver_image}></Avatar> :
                                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={row.driver_name} src={altProfile}></Avatar>
                                                            }
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                            <Grid2><Typography>{row.driver_name}</Typography></Grid2>
                                                            <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{driverDataShown == 0 ? row.driver_phone_number : (() => {
                                                            if (!row.driver_phone_number) return '****';
                                                            const phone = row.driver_phone_number;
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}</Typography></Grid2>
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.vehicle_number}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.session_status==1 ? '#F5BB19' : row.session_status==2 ? '#0DBA78' : '#D14545'  }}>{(row.session_status==0 || row.session_status==null) ? 'Not Started' : row.session_status==1 ? 'Started' : row.session_status==2 ? 'Ended' : '--'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.trip_id}</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Typography sx={{ width: 'auto', minWidth: '100px', color:'#0065FF', cursor: 'pointer' }} onClick={() => viewRoute(row)}>View Route</Typography>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.trip_date.split('T')[0]}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.time}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ticket_count}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.seat_numbers}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pickup_address}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.drop_address}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{dayjs(row.pickup_time).format('DD-MM-YYYY HH:mm:ss')}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{dayjs(row.drop_time).format('DD-MM-YYYY HH:mm:ss')}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{dayjs(row.booked_at).format('DD-MM-YYYY HH:mm:ss')}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{((row.fare) * row.ticket_count)}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.paid_using_wallet}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.paid_using_razorpay}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.promo_title == null ? '-' : row.promo_title}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.discounted_fare == null ? '-' : row.discounted_fare}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.payment_status === 0 ? 'PENDING' : row.payment_status === 1 ? 'PAID' : 'FAILED'}</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Typography
                                                        sx={{
                                                            width: 'auto',
                                                            minWidth: '120px',
                                                            color:
                                                                row.status === 1 ? '#6e706f' :
                                                                row.status === 2 ? '#D14545' :
                                                                row.status === 3 ? '#FFA500' : // Orange for PICKED_UP
                                                                row.status === 6 ? '#0DBA78' : // SlateBlue for ENDED
                                                                row.status === 7 ? '#ab434b' :
                                                                '#000',
                                                            fontWeight: '500',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                    
                                                        {{
                                                            1: 'Booked',
                                                            2: 'Cancelled',
                                                            3: 'Onboarded',
                                                            6: 'Ended',
                                                            7: 'Missed'
                                                        }[row.status] || 'Unknown'}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.cancellation_reason}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.refund_amount}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.refund_percentage}</Typography></TableCell>
                                                <TableCell align="center">
                                                    {row.cancellation_time && (
                                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                            {row.time_description} <br/> <hr/>
                                                            ({new Date(row.cancellation_time + ' UTC').toLocaleString()})
                                                        </Typography>
                                                    )}
                                                    {row.cancellation_time==null && (
                                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                            --
                                                        </Typography>
                                                    )}
                                                    
                                                </TableCell>

                                                <TableCell align="center">
                                                    {row.can_refund_to_source == 1 ? (
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => handleOpenRefundModal(row)}
                                                            sx={{ textTransform: 'none', bgcolor: '#0065ff', boxShadow: 'none', color: '#fff', height: '36px', borderRadius: '4px' }}
                                                        >
                                                            Refund
                                                        </Button>
                                                    ) : (
                                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>--</Typography>
                                                    )}
                                                </TableCell>
                                                {/* <TableCell align="center">
                                                    <Button variant="contained"
                                                        // onClick={() => viewData(row)}
                                                        sx={{
                                                            backgroundColor: "white", color: "black", border: "1px solid black",textTransform: "none", 
                                                            borderRadius: "8px", width: "auto", minWidth: "120px", marginBottom: "10px",
                                                            "&:hover": {backgroundColor: "black", color: "white"},
                                                            "&:active": {backgroundColor: "black",color: "white"},
                                                        }}
                                                        >
                                                        View Details
                                                    </Button>
                                                </TableCell> */}
                                            </TableRow>
                                        )
                                    })
                                    )}
                                </TableBody>
                            </Table>

                            <div className="custom-pagination">
                                <div className="pagination-info">
                                    {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                        (page + 1) * rowsPerPage,
                                        filteredRows.length
                                    )} of ${filteredRows.length} entries`}
                                </div>
                                <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePage(null, page - 1)}
                                    disabled={page === 0}
                                    className="pagination-arrow"
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                                
                                    <div className="pagination-numbers">
                                        {/* {[...Array(Math.ceil(filteredRows.length / rowsPerPage))].map((_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => handleChangePage(null, index)}
                                                className={`pagination-number ${
                                                    page === index ? 'active' : ''
                                                }`}
                                            >
                                                {index + 1}
                                            </button>
                                        ))} */}
                                        {page > 1 && (
                                            <>
                                                <button onClick={() => handleChangePage(null, 0)} className="pagination-number">
                                                    1
                                                </button>
                                                <span className="pagination-dots">...</span>
                                            </>
                                        )}
                                        {[...Array(Math.ceil(filteredRows.length / rowsPerPage))]
                                            .map((_, index) => index)
                                            .filter((index) => index >= page - 1 && index <= page + 1) // Show only previous, current, and next page
                                            .map((index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handleChangePage(null, index)}
                                                    className={`pagination-number ${page === index ? 'active' : ''}`}
                                                >
                                                    {index + 1}
                                                </button>
                                        ))}

                                        {page < Math.ceil(filteredRows.length / rowsPerPage) - 2 && (
                                            <>
                                                <span className="pagination-dots">...</span>
                                                <button
                                                    onClick={() => handleChangePage(null, Math.ceil(filteredRows.length / rowsPerPage) - 1)}
                                                    className="pagination-number"
                                                >
                                                    {Math.ceil(filteredRows.length / rowsPerPage)}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleChangePage(null, page + 1)}
                                        disabled={page >= Math.ceil(filteredRows.length / rowsPerPage) - 1}
                                        className="pagination-arrow"
                                    >
                                        <img src={nextIcon} alt="Next" />
                                    </button>
                                </div>
                            </div>
                        </TableContainer>
                    </Paper>
                </TabPanel>

                <TabPanel value="2" style={{padding:' 0% 0%'}}>
                    <Paper elevation={2} style={{padding:'2%'}}>
                        <Grid2 item container spacing={2}>
                            <Grid2 item>
                                <Select value={cityFilterfortab2} 
                                onChange={(e) => handleCityChangefortab2(e.target.value)} displayEmpty
                                style={{width: '140px',height:'48px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                    {clientRole == 1 && <MenuItem value="">Select City</MenuItem>}
                                    {cities.map((city) => (
                                        <MenuItem key={city.city_name} value={city.city_id}>
                                            {city.city_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>
                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                        '& .MuiInputBase-root': {
                                        height: '50px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        }
                                    }}
                                    value={dateFilterTab2}
                                    onChange={(newValue) => setDateFilterTab2(newValue)}
                                    />
                                </LocalizationProvider>
                            </Grid2>
                            <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="number" 
                                    placeholder="User Phone Number" 
                                    className="filterBtn"
                                    value={userPhoneFilterTab2} 
                                    onChange={handleUserPhoneChangeTab2}
                                    style={{ width: '100%' }}
                                />
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button variant='contained' style={{width: '120px', height: '44px', backgroundColor:'#36C68F', textTransform:'none', borderRadius:'8px',marginLeft:'auto'}}> 
                                    <CSVLink
                                        data={bookingRefundLogs}
                                        headers={headersTab2}
                                        filename={"Booking Refund Logs.csv"}
                                        style={{ textDecoration: 'none' }}
                                    > 
                                        <Typography sx={{color: '#fff'}}>Export CSV</Typography>
                                    </CSVLink>
                                </Button>
                            </Grid2>
                        </Grid2>

                        <TableContainer className="table-container" style={{maxHeight:'60vh'}}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'id'} direction={orderBy === 'id' ? order : 'asc'}
                                                onClick={() => handleRequestSortTab2('id')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%'}}>
                                            <Typography sx={{padding:'12px'}}>User</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'200px' }}>
                                            <Typography sx={{padding:'12px'}}>Requested Seats</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'booking_id'} direction={orderBy === 'booking_id' ? order : 'asc'}
                                                onClick={() => handleRequestSortTab2('booking_id')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Seat booked by Booking ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'request_time'} direction={orderBy === 'request_time' ? order : 'asc'}
                                                onClick={() => handleRequestSortTab2('request_time')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Request Time
                                            </TableSortLabel>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {paginatedDataTab2.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={13} align="center">
                                                <Typography variant="body1">No data found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                    paginatedDataTab2.map((row) => {
                                        return (
                                            <TableRow key={row.id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.id}</Typography></TableCell>
                                                <TableCell>
                                                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                        <Grid2>
                                                            {
                                                                row.user_image ? <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={row.user_name} src={row.user_image}></Avatar> :
                                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt={row.user_name} src={altProfile}></Avatar>
                                                            }
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                            <Grid2><Typography>{row.user_name}</Typography></Grid2>
                                                            <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{clientdataShown == 0 ? row.phone_number : (() => {
                                                            if (!row.phone_number) return '****';
                                                            const phone = row.phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}</Typography></Grid2>
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.requested_seats}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.seat_booked_by_booking_id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{dayjs(row.request_time).format('YYYY-MM-DD HH:mm:ss')}</Typography></TableCell>
                                            </TableRow>
                                        );
                                    })
                                )}
                                </TableBody>
                                
                            </Table>
                            <div className="custom-pagination">
                                <div className="pagination-info">
                                    {`Showing ${pageTab2 * rowsPerPageTab2 + 1} to ${Math.min(
                                        (pageTab2 + 1) * rowsPerPageTab2,
                                        filteredRowsTab2.length
                                    )} of ${filteredRowsTab2.length} entries`}
                                </div>
                                <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePageTab2(null, pageTab2 - 1)}
                                    disabled={pageTab2 === 0}
                                    className="pagination-arrow"
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                                
                                    <div className="pagination-numbers">
                                        {pageTab2 > 1 && (
                                            <>
                                                <button onClick={() => handleChangePageTab2(null, 0)} className="pagination-number">
                                                    1
                                                </button>
                                                <span className="pagination-dots">...</span>
                                            </>
                                        )}
                                        {[...Array(Math.ceil(filteredRowsTab2.length / rowsPerPageTab2))]
                                            .map((_, index) => index)
                                            .filter((index) => index >= pageTab2 - 1 && index <= pageTab2 + 1) // Show only previous, current, and next page
                                            .map((index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handleChangePageTab2(null, index)}
                                                    className={`pagination-number ${pageTab2 === index ? 'active' : ''}`}
                                                >
                                                    {index + 1}
                                                </button>
                                        ))}

                                        {pageTab2 < Math.ceil(filteredRowsTab2.length / rowsPerPageTab2) - 2 && (
                                            <>
                                                <span className="pagination-dots">...</span>
                                                <button
                                                    onClick={() => handleChangePageTab2(null, Math.ceil(filteredRowsTab2.length / rowsPerPageTab2) - 1)}
                                                    className="pagination-number"
                                                >
                                                    {Math.ceil(filteredRowsTab2.length / rowsPerPageTab2)}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleChangePageTab2(null, pageTab2 + 1)}
                                        disabled={pageTab2 >= Math.ceil(filteredRowsTab2.length / rowsPerPageTab2) - 1}
                                        className="pagination-arrow"
                                    >
                                        <img src={nextIcon} alt="Next" />
                                    </button>
                                </div>
                            </div>
                        </TableContainer>
                    </Paper>
                </TabPanel>

                <TabPanel value="3" style={{padding:' 0% 0%'}}>
                    <Paper elevation={2} style={{padding:'2%'}}>
                        <Grid2 item container spacing={2}>
                            <Grid2 item>
                                <Select value={cityFilterfortab3} 
                                onChange={(e) => handleCityChangefortab3(e.target.value)} displayEmpty
                                style={{width: '140px',height:'42px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                    {clientRole == 1 && <MenuItem value="">Select City</MenuItem>}
                                    {cities.map((city) => (
                                        <MenuItem key={city.city_name} value={city.city_id}>
                                            {city.city_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>
                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                        '& .MuiInputBase-root': {
                                        height: '50px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        }
                                    }}
                                    value={dateFilterTab3}
                                    onChange={(newValue) => setDateFilterTab3(newValue)}
                                    />
                                </LocalizationProvider>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button variant='contained' style={{width: '120px', height: '44px', backgroundColor:'#36C68F', textTransform:'none', borderRadius:'8px',marginLeft:'auto'}}> 
                                    <CSVLink
                                        data={formatDataForCSVTab3(driverTrips)}
                                        headers={headersTab3}
                                        filename={"DriverTrips.csv"}
                                        style={{ textDecoration: 'none' }}
                                    > 
                                        <Typography sx={{color: '#fff'}}>Export CSV</Typography>
                                    </CSVLink>
                                </Button>
                            </Grid2>
                        </Grid2>

                        <TableContainer className="table-container" style={{maxHeight:'60vh'}}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'session_id'} direction={orderBy === 'session_id' ? order : 'asc'}
                                                onClick={() => handleRequestSortTab3('session_id')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Session ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'trip_id'} direction={orderBy === 'trip_id' ? order : 'asc'}
                                                onClick={() => handleRequestSortTab3('trip_id')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Trip ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%'}}>
                                            <Typography sx={{padding:'12px'}}>Driver</Typography>
                                        </TableCell>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'start_time'} direction={orderBy === 'start_time' ? order : 'asc'}
                                                onClick={() => handleRequestSortTab3('start_time')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Start Time
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel className='table-header' active={orderBy === 'end_time'} direction={orderBy === 'end_time' ? order : 'asc'}
                                                onClick={() => handleRequestSortTab3('end_time')} sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                End Time
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%'}}>
                                            <Typography sx={{padding:'12px'}}>Action</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {paginatedDataTab3.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={13} align="center">
                                                <Typography variant="body1">No data found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                    paginatedDataTab3.map((row) => {
                                        return (
                                            <TableRow key={row.session_id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.session_id}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.trip_id}</Typography></TableCell>
                                                <TableCell>
                                                    <Grid2 container sx={{ width: "auto", minWidth: "180px", alignItems: 'center', marginTop: '2%' }}>
                                                        <Grid2>
                                                            {row.driver_image ? (
                                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.driver_image} />
                                                            ) : (
                                                                <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile} />
                                                            )}
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                            <Typography sx={{ 
                                                                fontSize: '14px', textAlign: 'left', backgroundColor: '#FFFFFF', 
                                                                padding: '0px 2px', textDecoration: '#AC8312', borderRadius: "4px" 
                                                            }}>
                                                                {row.driver_id && (
                                                                <>
                                                                    <span style={{ color: '#9FA3A7' }}>Driver Id: </span>
                                                                    <span style={{ color: '#AC8312' }}>{row.driver_id}</span>
                                                                </>
                                                                )}
                                                            </Typography>
                                                            {row.driver_name && (
                                                                <Typography sx={{ color: '#4E545D', fontSize: '16px' }}>{row.driver_name}</Typography>
                                                            )}
                                                            {row.phone_number && (
                                                                <Typography sx={{ color: "#9FA3A7", fontSize: "12px" }}>{driverDataShown == 0 ? row.phone_number : (() => {
                                                            if (!row.phone_number) return '****';
                                                            const phone = row.phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()}</Typography>
                                                            )}
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                    {row.start_time ? 
                                                        (() => {
                                                        const pickupDate = new Date(row.start_time);
                                                        // Add the offset minutes to the date
                                                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                        return pickupDate.toLocaleString('en-GB', {
                                                            day: '2-digit', 
                                                            month: '2-digit', 
                                                            year: 'numeric', 
                                                            hour: '2-digit', 
                                                            minute: '2-digit', 
                                                            hour12: timeZoneFormat == '12' ? true : false,
                                                            timeZone: 'UTC'
                                                        }).replace(',', ' |');
                                                        })() 
                                                        : '--'
                                                    }
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                        {row.end_time ? 
                                                        (() => {
                                                        const pickupDate = new Date(row.end_time);
                                                        // Add the offset minutes to the date
                                                        pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                        return pickupDate.toLocaleString('en-GB', {
                                                            day: '2-digit', 
                                                            month: '2-digit', 
                                                            year: 'numeric', 
                                                            hour: '2-digit', 
                                                            minute: '2-digit', 
                                                            hour12: timeZoneFormat == '12' ? true : false,
                                                            timeZone: 'UTC'
                                                        }).replace(',', ' |');
                                                        })() 
                                                        : '--'
                                                    }
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Button variant="contained" 
                                                        onClick={() => handleViewTripDetails(row.session_id)}
                                                            sx={{
                                                                backgroundColor: "white", color: "black", border: "1px solid black", textTransform: "none", boxShadow:'none',
                                                                borderRadius: "8px", width: "auto", minWidth: "140px", marginBottom: "10px",
                                                                "&:hover": { backgroundColor: "black", color: "white" }, "&:active": {backgroundColor: "black",color: "white"}
                                                            }}
                                                        >
                                                            View Details
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                )}
                                </TableBody>
                                
                            </Table>
                            <div className="custom-pagination">
                                <div className="pagination-info">
                                    {`Showing ${pageTab3 * rowsPerPageTab3 + 1} to ${Math.min(
                                        (pageTab3 + 1) * rowsPerPageTab3,
                                        filteredRowsTab3.length
                                    )} of ${filteredRowsTab3.length} entries`}
                                </div>
                                <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePageTab3(null, pageTab3 - 1)}
                                    disabled={pageTab3 === 0}
                                    className="pagination-arrow"
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                                
                                    <div className="pagination-numbers">
                                        {pageTab3 > 1 && (
                                            <>
                                                <button onClick={() => handleChangePageTab3(null, 0)} className="pagination-number">
                                                    1
                                                </button>
                                                <span className="pagination-dots">...</span>
                                            </>
                                        )}
                                        {[...Array(Math.ceil(filteredRowsTab3.length / rowsPerPageTab3))]
                                            .map((_, index) => index)
                                            .filter((index) => index >= pageTab3 - 1 && index <= pageTab3 + 1) // Show only previous, current, and next page
                                            .map((index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handleChangePageTab3(null, index)}
                                                    className={`pagination-number ${pageTab3 === index ? 'active' : ''}`}
                                                >
                                                    {index + 1}
                                                </button>
                                        ))}

                                        {pageTab3 < Math.ceil(filteredRowsTab3.length / rowsPerPageTab3) - 2 && (
                                            <>
                                                <span className="pagination-dots">...</span>
                                                <button
                                                    onClick={() => handleChangePageTab3(null, Math.ceil(filteredRowsTab3.length / rowsPerPageTab3) - 1)}
                                                    className="pagination-number"
                                                >
                                                    {Math.ceil(filteredRowsTab3.length / rowsPerPageTab3)}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleChangePageTab3(null, pageTab3 + 1)}
                                        disabled={pageTab3 >= Math.ceil(filteredRowsTab3.length / rowsPerPageTab3) - 1}
                                        className="pagination-arrow"
                                    >
                                        <img src={nextIcon} alt="Next" />
                                    </button>
                                </div>
                            </div>
                        </TableContainer>
                    </Paper>
                </TabPanel>

                <TabPanel value="4" style={{padding:' 0% 0%'}}>
                    <Paper elevation={2} style={{padding:'2%'}}>
                        <Grid2 item container spacing={2}>
                            <Grid2 item>
                                <Select value={cityFilterfortab4} 
                                onChange={(e) => handleCityChangefortab4(e.target.value)} displayEmpty
                                style={{width: '140px',height:'48px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                    {clientRole == 1 && <MenuItem value="">Select City</MenuItem>}
                                    {cities.map((city) => (
                                        <MenuItem key={city.city_name} value={city.city_id}>
                                            {city.city_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>

                            <Grid2 xs="auto" sx={{ width: '150px', height:'50px',marginRight:'1%' }}>
                                <input type="number" placeholder="Booking Id" className="filterBtn" value={bookingIdFilter} onChange={handleBookingIdChange} style={{ width: '100%' }} min="0"
                                    onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                                        e.preventDefault();
                                    }
                                    }}
                                />
                            </Grid2>


                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                        '& .MuiInputBase-root': {
                                            minHeight: '48px',
                                            height: '48px',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                        }
                                    }}
                                    value={startdatetab4}
                                    onChange={(newValue) => setStartdatetab4(newValue)}
                                    minDate={endDateFilter.subtract(31, 'day')}
                                    maxDate={endDateFilter}
                                    />
                                </LocalizationProvider>
                            </Grid2>

                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                    '& .MuiInputBase-root': {
                                        minHeight: '48px', // or your desired height
                                        height: '48px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        alignItems: 'center',
                                    },
                                    '& input': {
                                        padding: '24px 14px', // increase vertical padding as needed   // optional: increase font size
                                    },
                                    }}
                                    value={enddatetab4}
                                    onChange={(newValue) => {
                                        const daysDiff = newValue.diff(startdatetab4, 'days');
                                    
                                        setEnddatetab4(newValue);
                                    
                                        if (daysDiff > 31) {
                                            setDateFilter(newValue.clone().subtract(31, 'days'));
                                        }
                                    }}
                                    minDate={endDateFilter.subtract(31, 'day')}
                                    maxDate={endDateFilter}
                                    />
                                </LocalizationProvider>
                            </Grid2>
                            <Grid2 item xs="auto">
                            <Box sx={{p:'1% 2%', border: '1px solid #ccc', borderRadius: 2, display: 'flex', alignItems: 'center', gap: 1, background: '#f9f9f9', minWidth: 250 ,minHeight:'42px'}}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, }}>Total</Typography>
                                <Typography variant="body2" sx={{ color: '#666'}}>Booking</Typography>
                                <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 700 }}>{filteredRowsTab4.length}</Typography>
                                <Typography variant="body2" sx={{ color: '#666', }}>Reschedule</Typography>
                                <Typography variant="h6" sx={{ color: '#1976d2', fontWeight: 700 }}>{filteredRowsTab4.reduce((sum, row) => sum + (Number(row.total_reschedules) || 0), 0)}</Typography>
                            </Box>
                            </Grid2>

                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button variant='contained' style={{width: '120px', height: '48px', backgroundColor:'#36C68F', textTransform:'none', borderRadius:'8px',marginLeft:'auto'}}> 
                                    <CSVLink
                                        data={(() => {
                                            const csvData = [];
                                            filteredRowsTab4.forEach(row => {
                                                const reschedules = extractReschedules(row);
                                                reschedules.forEach((r, index) => {
                                                    csvData.push({
                                                        'Booking ID': index === 0 ? row.booking_id : '',
                                                        'No Of Reschedules': index === 0 ? row.total_reschedules : '',
                                                        'User Details': index === 0 ? `${row.user_name} (${clientdataShown == 0 ? row.user_phone_number : (() => {
                                                            if (!row.user_phone_number) return '****';
                                                            const phone = row.user_phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()})` : '',
                                                        'Reschedule Count': r.prefix,
                                                        'Prev Driver': r.prev_driver_name ? `${r.prev_driver_name} (${driverDataShown == 0 ? r.prev_driver_phone_number : (() => {
                                                            if (!r.prev_driver_phone_number) return '****';
                                                            const phone = r.prev_driver_phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()})` : '--',
                                                        'New Driver': r.new_driver_name ? `${r.new_driver_name} (${driverDataShown == 0 ? r.new_driver_phone_number : (() => {
                                                            if (!r.new_driver_phone_number) return '****';
                                                            const phone = r.new_driver_phone_number;
                                                            // Remove any non-digit characters for processing
                                                            const cleanPhone = phone.replace(/\D/g, '');
                                                            if (cleanPhone.length <= 4) return '****';
                                                            const firstTwo = cleanPhone.substring(0, 2);
                                                            const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                            const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                            return "+" + firstTwo + maskedMiddle + lastTwo;
                                                        })()})` : '--',
                                                        'Prev Trip Id': r.prev_trip_id ?? '--',
                                                        'New Trip Id': r.new_trip_id ?? '--',
                                                        'Prev Trip Date': r.prev_trip_date ? dayjs(r.prev_trip_date).format('DD-MM-YYYY') : '--',
                                                        'New Trip Date': r.new_trip_date ? dayjs(r.new_trip_date).format('DD-MM-YYYY') : '--',
                                                        'Prev Pickup Time': r.prev_pickup_time ? dayjs(r.prev_pickup_time).format('HH:mm:ss') : '--',
                                                        'New Pickup Time': r.new_pickup_time ? dayjs(r.new_pickup_time).format('HH:mm:ss') : '--',
                                                        'Prev Drop Time': r.prev_drop_time ? dayjs(r.prev_drop_time).format('HH:mm:ss') : '--',
                                                        'New Drop Time': r.new_drop_time ? dayjs(r.new_drop_time).format('HH:mm:ss') : '--',
                                                        'Prev Ticket Count': r.prev_ticket_count ?? '--',
                                                        'New Ticket Count': r.new_ticket_count ?? '--',
                                                        'Prev Seat Number': r.prev_seat_numbers ?? '--',
                                                        'New Seat Number': r.new_seat_numbers ?? '--',
                                                        'Prev Fare': r.prev_fare ?? '--',
                                                        'New Fare': r.new_fare ?? '--',
                                                        'Prev PickUp Stop Name': r.prev_pickup_stop_name ?? '--',
                                                        'New PickUp Stop Name': r.new_pickup_stop_name ?? '--',
                                                        'Prev Drop Stop Name': r.prev_drop_stop_name ?? '--',
                                                        'New Drop Stop Name': r.new_drop_stop_name ?? '--'
                                                    });
                                                });
                                            });
                                            return csvData;
                                        })()}
                                        headers={[
                                            { label: 'Booking ID', key: 'Booking ID' },
                                            { label: 'No Of Reschedules', key: 'No Of Reschedules' },
                                            { label: 'User Details', key: 'User Details' },
                                            { label: 'Reschedule Count', key: 'Reschedule Count' },
                                            { label: 'Prev Driver', key: 'Prev Driver' },
                                            { label: 'New Driver', key: 'New Driver' },
                                            { label: 'Prev Trip Id', key: 'Prev Trip Id' },
                                            { label: 'New Trip Id', key: 'New Trip Id' },
                                            { label: 'Prev Trip Date', key: 'Prev Trip Date' },
                                            { label: 'New Trip Date', key: 'New Trip Date' },
                                            { label: 'Prev Pickup Time', key: 'Prev Pickup Time' },
                                            { label: 'New Pickup Time', key: 'New Pickup Time' },
                                            { label: 'Prev Drop Time', key: 'Prev Drop Time' },
                                            { label: 'New Drop Time', key: 'New Drop Time' },
                                            { label: 'Prev Ticket Count', key: 'Prev Ticket Count' },
                                            { label: 'New Ticket Count', key: 'New Ticket Count' },
                                            { label: 'Prev Seat Number', key: 'Prev Seat Number' },
                                            { label: 'New Seat Number', key: 'New Seat Number' },
                                            { label: 'Prev Fare', key: 'Prev Fare' },
                                            { label: 'New Fare', key: 'New Fare' },
                                            { label: 'Prev PickUp Stop Name', key: 'Prev PickUp Stop Name' },
                                            { label: 'New PickUp Stop Name', key: 'New PickUp Stop Name' },
                                            { label: 'Prev Drop Stop Name', key: 'Prev Drop Stop Name' },
                                            { label: 'New Drop Stop Name', key: 'New Drop Stop Name' }
                                        ]}
                                        filename={"Reschedule Data.csv"}
                                        style={{ textDecoration: 'none' }} // Add this line to remove underline
                                    > 
                                        <Typography sx={{color: '#fff'}}>Export CSV</Typography>
                                    </CSVLink>
                                </Button>
                            </Grid2>

                        </Grid2>

                        <TableContainer className="table-container" style={{maxHeight:'60vh'}}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel 
                                                className='table-header' 
                                                active={orderBy === 'booking_id'} 
                                                direction={orderBy === 'booking_id' ? order : 'asc'}
                                                onClick={() => handleRequestSort('booking_id')} 
                                                sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Booking ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            No Of Reschedules
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            User Details
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            Reschedule Count
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Prev Driver 
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            New Driver
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Prev Trip Id
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            New Trip Id
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            Prev Trip Date
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            New Trip Date
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            Prev Pickup Time
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            New Pickup Time
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            Prev Drop Time
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            New Drop Time
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Prev Ticket Count
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            New Ticket Count
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Prev Seat Number
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            New Seat Number
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '100px' }}>
                                            Prev Fare
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '100px' }}>
                                            New Fare
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            Prev PickUp Stop Name
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            New PickUp Stop Name
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            Prev Drop Stop Name
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '150px' }}>
                                            New Drop Stop Name
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {loading ? (
                                        <TableRow>
                                        <TableCell colSpan={25} align="center">
                                            <LinearProgress />
                                        </TableCell>
                                        </TableRow>
                                    ) : paginatedDataTab4.length === 0 ? (
                                        <TableRow>
                                        <TableCell colSpan={25} align="center">
                                            <Typography variant="body1">No data found</Typography>
                                        </TableCell>
                                        </TableRow>
                                    ) : (
                                        paginatedDataTab4.map((row) => {
                                        const reschedules = extractReschedules(row); // R1/R2/R3 parser

                                        return (
                                            <React.Fragment key={row.booking_id}>
                                            {reschedules.map((r, index) => (
                                            <TableRow
                                            key={`${row.booking_id}_${index}`}
                                            sx={{
                                                borderBottom:
                                                index === reschedules.length - 1 && row !== paginatedDataTab4[paginatedDataTab4.length - 1]
                                                    ? '3px solid #800e0eff !important'
                                                    : '1px solid #e8e4e4ff !important',
                                                '& td': {
                                                borderBottom:
                                                    index === reschedules.length - 1 && row !== paginatedDataTab4[paginatedDataTab4.length - 1]
                                                    ? '3px solid #f3c6c6ff !important'
                                                    : '1px solid #e8e4e4ff !important',
                                                },
                                            }}
                                            >                                                
                                                {/* Booking ID only for first row */}
                                                <TableCell align="center">
                                                    {index === 0 ? (
                                                    <Typography sx={{ minWidth: "100px", fontWeight: 600 }}>
                                                        {row.booking_id}
                                                    </Typography>
                                                    ) : (
                                                    ""
                                                    )}
                                                </TableCell>

                                                {/* Total Reschedules only for first row */}
                                                <TableCell align="center">
                                                    {index === 0 ? (
                                                    <Typography sx={{ minWidth: "100px", fontWeight: 600 }}>
                                                        {row.total_reschedules}
                                                    </Typography>
                                                    ) : (
                                                    ""
                                                    )}
                                                </TableCell>

                                                <TableCell>
                                                    {index === 0 ? (
                                                    <Typography sx={{ minWidth: "100px" }}>{row.user_name ? <Grid2 container sx={{ width: 'auto', minWidth: '180px' }}>
                                                        <Grid2>
                                                            <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt={row.user_name} src={row.user_image || altProfile} />
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                                                            <Grid2>
                                                                <Typography>{row.user_name}</Typography>
                                                            </Grid2>
                                                            <Grid2>
                                                                <Typography sx={{ color: '#83888E', fontSize: '12px' }}>
                                                                    {clientdataShown == 0 ? row.user_phone_number : (() => {
                                                                        if (!row.user_phone_number) return '****';
                                                                        const phone = row.user_phone_number;
                                                                        // Remove any non-digit characters for processing
                                                                        const cleanPhone = phone.replace(/\D/g, '');
                                                                        if (cleanPhone.length <= 4) return '****';
                                                                        const firstTwo = cleanPhone.substring(0, 2);
                                                                        const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                                        const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                                        return "+" + firstTwo + maskedMiddle + lastTwo;
                                                                    })()}
                                                                </Typography>
                                                            </Grid2>
                                                        </Grid2>
                                                    </Grid2> : "--"}</Typography>
                                                    ) : (
                                                    ""
                                                    )}
                                                </TableCell>

                                                {/* R# */}
                                                <TableCell align="center">
                                                    <Typography sx={{ minWidth: "100px" }}>{r.prefix}</Typography>
                                                </TableCell>

                                                {/* Prev Driver Id */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_driver_id_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_driver_id ? <Grid2 container sx={{ width: 'auto', minWidth: '180px' }}>
                                                        <Grid2>
                                                            <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt={row.user_name} src={r.prev_driver_image || altProfile} />
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                                                            <Grid2>
                                                                <Typography>{r.prev_driver_name}</Typography>
                                                            </Grid2>
                                                            <Grid2>
                                                                <Typography sx={{ color: row[`${r.prefix}_driver_id_changed`] ? '#272727ff' : '#83888E', fontSize: '12px' }}>
                                                                    {/* {r.prev_driver_phone_number} */}
                                                                    {driverDataShown == 0 ? r.prev_driver_phone_number : (() => {
                                                                        if (!r.prev_driver_phone_number) return '****';
                                                                        const phone = r.prev_driver_phone_number;
                                                                        // Remove any non-digit characters for processing
                                                                        const cleanPhone = phone.replace(/\D/g, '');
                                                                        if (cleanPhone.length <= 4) return '****';
                                                                        const firstTwo = cleanPhone.substring(0, 2);
                                                                        const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                                        const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                                        return "+" + firstTwo + maskedMiddle + lastTwo;
                                                                    })()}
                                                                </Typography>
                                                            </Grid2>
                                                        </Grid2>
                                                    </Grid2> : "--"}
                                                </TableCell>

                                                {/* New Driver Id */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_driver_id_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_driver_id ? <Grid2 container sx={{ width: 'auto', minWidth: '180px' }}>
                                                        <Grid2>
                                                            <Avatar sx={{ borderColor: '#0065FF', border: 1 }} alt={row.user_name} src={r.new_driver_image || altProfile} />
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: '8px', textAlign: 'left' }}>
                                                            <Grid2>
                                                                <Typography>{r.new_driver_name}</Typography>
                                                            </Grid2>
                                                            <Grid2>
                                                                <Typography sx={{ color: row[`${r.prefix}_driver_id_changed`] ? '#272727ff' : '#83888E', fontSize: '12px' }}>
                                                                    {driverDataShown == 0 ? r.new_driver_phone_number : (() => {
                                                                        if (!r.new_driver_phone_number) return '****';
                                                                        const phone = r.new_driver_phone_number;
                                                                        // Remove any non-digit characters for processing
                                                                        const cleanPhone = phone.replace(/\D/g, '');
                                                                        if (cleanPhone.length <= 4) return '****';
                                                                        const firstTwo = cleanPhone.substring(0, 2);
                                                                        const lastTwo = cleanPhone.substring(cleanPhone.length - 2);
                                                                        const maskedMiddle = '*'.repeat(cleanPhone.length - 4);
                                                                        return "+" + firstTwo + maskedMiddle + lastTwo;
                                                                    })()}
                                                                </Typography>
                                                            </Grid2>
                                                        </Grid2>
                                                    </Grid2> : "--"}
                                                </TableCell>

                                                {/* Prev Trip Id */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_trip_id_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_trip_id ?? "--"}
                                                </TableCell>

                                                {/* New Trip Id */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_trip_id_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_trip_id ?? "--"}
                                                </TableCell>

                                                {/* Prev Trip Date */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_trip_date_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_trip_date
                                                    ? dayjs(r.prev_trip_date).format("DD-MM-YYYY")
                                                    : "--"}
                                                </TableCell>

                                                {/* New Trip Date */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_trip_date_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_trip_date
                                                    ? dayjs(r.new_trip_date).format("DD-MM-YYYY")
                                                    : "--"}
                                                </TableCell>

                                                {/* Prev Pickup Time */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_pickup_time_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_pickup_time
                                                    ? dayjs(r.prev_pickup_time).format("HH:mm:ss")
                                                    : "--"}
                                                </TableCell>

                                                {/* New Pickup Time */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_pickup_time_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_pickup_time
                                                    ? dayjs(r.new_pickup_time).format("HH:mm:ss")
                                                    : "--"}
                                                </TableCell>

                                                {/* Prev Drop Time */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_drop_time_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_drop_time
                                                    ? dayjs(r.prev_drop_time).format("HH:mm:ss")
                                                    : "--"}
                                                </TableCell>

                                                {/* New Drop Time */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_drop_time_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_drop_time
                                                    ? dayjs(r.new_drop_time).format("HH:mm:ss")
                                                    : "--"}
                                                </TableCell>

                                                {/* Prev Ticket Count */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_ticket_count_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_ticket_count ?? "--"}
                                                </TableCell>

                                                {/* New Ticket Count */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_ticket_count_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_ticket_count ?? "--"}
                                                </TableCell>

                                                {/* Prev Seat Number */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_seat_numbers_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_seat_numbers ?? "--"}
                                                </TableCell>

                                                {/* New Seat Number */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_seat_numbers_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_seat_numbers ?? "--"}
                                                </TableCell>

                                                {/* Prev Fare */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_fare_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_fare ?? "--"}
                                                </TableCell>

                                                {/* New Fare */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_fare_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_fare ?? "--"}
                                                </TableCell>

                                                {/* Prev Pickup Stop */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_pickup_stop_name_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_pickup_stop_name ?? "--"}
                                                </TableCell>

                                                {/* New Pickup Stop */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_pickup_stop_name_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_pickup_stop_name ?? "--"}
                                                </TableCell>

                                                {/* Prev Drop Stop */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_drop_stop_name_changed`] ? '#f2a0a7' : 'inherit'
                                                    }}
                                                >
                                                    {r.prev_drop_stop_name ?? "--"}
                                                </TableCell>

                                                {/* New Drop Stop */}
                                                <TableCell 
                                                    align="center"
                                                    sx={{ 
                                                        backgroundColor: row[`${r.prefix}_drop_stop_name_changed`] ? '#a2ebb8' : 'inherit'
                                                    }}
                                                >
                                                    {r.new_drop_stop_name ?? "--"}
                                                </TableCell>

                                                </TableRow>
                                            ))}
                                            </React.Fragment>
                                        );
                                        })
                                    )}
                                    </TableBody>

                            </Table>

                            <div className="custom-pagination">
                                <div className="pagination-info">
                                    {`Showing ${pageTab4 * rowsPerPage + 1} to ${Math.min(
                                        (pageTab4 + 1) * rowsPerPage,
                                        filteredRowsTab4.length
                                    )} of ${filteredRowsTab4.length} entries`}
                                </div>
                                <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePagefortab4(null, pageTab4 - 1)}
                                    disabled={pageTab4 === 0}
                                    className="pagination-arrow"
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                                
                                    <div className="pagination-numbers">
                                        {/* {[...Array(Math.ceil(filteredRows.length / rowsPerPage))].map((_, index) => (
                                            <button
                                                key={index}
                                                onClick={() => handleChangePage(null, index)}
                                                className={`pagination-number ${
                                                    page === index ? 'active' : ''
                                                }`}
                                            >
                                                {index + 1}
                                            </button>
                                        ))} */}
                                        {pageTab4 > 1 && (
                                            <>
                                                <button onClick={() => handleChangePagefortab4(null, 0)} className="pagination-number">
                                                    1
                                                </button>
                                                <span className="pagination-dots">...</span>
                                            </>
                                        )}
                                        {[...Array(Math.ceil(filteredRowsTab4.length / rowsPerPage))]
                                            .map((_, index) => index)
                                            .filter((index) => index >= pageTab4 - 1 && index <= pageTab4 + 1) // Show only previous, current, and next page
                                            .map((index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handleChangePagefortab4(null, index)}
                                                    className={`pagination-number ${pageTab4 === index ? 'active' : ''}`}
                                                >
                                                    {index + 1}
                                                </button>
                                        ))}

                                        {pageTab4 < Math.ceil(filteredRowsTab4.length / rowsPerPage) - 2 && (
                                            <>
                                                <span className="pagination-dots">...</span>
                                                <button
                                                    onClick={() => handleChangePagefortab4(null, Math.ceil(filteredRowsTab4.length / rowsPerPage) - 1)}
                                                    className="pagination-number"
                                                >
                                                    {Math.ceil(filteredRowsTab4.length / rowsPerPage)}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleChangePagefortab4(null, pageTab4 + 1)}
                                        disabled={pageTab4 >= Math.ceil(filteredRowsTab4.length / rowsPerPage) - 1}
                                        className="pagination-arrow"
                                    >
                                        <img src={nextIcon} alt="Next" />
                                    </button>
                                </div>
                            </div>
                        </TableContainer>
                    </Paper>
                </TabPanel>


                <TabPanel value="5" style={{padding:' 0% 0%'}}>
                    <Paper elevation={2} style={{padding:'2%'}}>
                        <Grid2 item container spacing={2}>
                            <Grid2 item>
                                <Select value={cityFilterfortab5} 
                                onChange={(e) => handleCityChangefortab5(e.target.value)} displayEmpty
                                style={{width: '140px',height:'48px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                    {clientRole == 1 && <MenuItem value="">Select City</MenuItem>}
                                    {cities.map((city) => (
                                        <MenuItem key={city.city_name} value={city.city_id}>
                                            {city.city_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>

                            <Grid2 item xs="auto">
                                <Select value={selectedRouteIdTab5} 
                                    onChange={(e) => handleRouteChangeTab5(e)} displayEmpty
                                    style={{width: '240px',height:'48px',borderRadius:'8px'}}>
                                        <MenuItem value="">Select Route</MenuItem>
                                        {routesDataTab5.map((route) => (
                                            <MenuItem key={route.route_name} value={route.route_id}>
                                                {route.route_name}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </Grid2>

                            <Grid2 item xs="auto">
                                <Select value={selectedVehicleIdTab5} 
                                    onChange={(e) => handleVehicleChangeTab5(e)} displayEmpty
                                    style={{width: '190px',height:'48px',borderRadius:'8px'}}>
                                        <MenuItem value="">Select Vehicle</MenuItem>
                                        {vehicleDataTab5.map((vehicle) => (
                                            <MenuItem key={vehicle.vehicle_name} value={vehicle.id}>
                                                {vehicle.vehicle_number}
                                            </MenuItem>
                                        ))}
                                        
                                </Select>
                            </Grid2>

                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                        '& .MuiInputBase-root': {
                                            minHeight: '48px',
                                            height: '48px',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                        }
                                    }}
                                    value={startdatetab5}
                                    onChange={(newValue) => {
                                    if (enddatetab5 && newValue && newValue.isAfter(enddatetab5)) {
                                        setEnddatetab5(null);
                                    }
                                    setStartdatetab5(newValue);
                                    }}
                                maxDate={enddatetab5 || undefined}
                                    />
                                </LocalizationProvider>
                            </Grid2>

                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                    '& .MuiInputBase-root': {
                                        minHeight: '48px', // or your desired height
                                        height: '48px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        alignItems: 'center',
                                    },
                                    '& input': {
                                        padding: '24px 14px', // increase vertical padding as needed   // optional: increase font size
                                    },
                                    }}
                                    value={enddatetab5}
                                    onChange={(newValue) => {
                                        setEnddatetab5(newValue)
                                    }}
                                    minDate={startdatetab5 || undefined}
                                    maxDate={endDateFilter}
                                    />
                                </LocalizationProvider>
                            </Grid2>

                            <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="text"  // Changed from number to text to have more control
                                    placeholder="Trip Id" 
                                    className="filterBtn"
                                    value={tripIdTab5} 
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '');
                                        setTripIdTab5(value);
                                    }}
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    style={{ 
                                        width: '100%',
                                        height: '48px',
                                        borderRadius: '8px',
                                        padding: '0 12px',
                                        border: '1px solid #ccc',
                                        fontSize: '14px'
                                    }}
                                />
                            </Grid2>

                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button 
                                    variant='contained' 
                                    style={{
                                        width: '120px', 
                                        height: '48px', 
                                        backgroundColor:'#36C68F', 
                                        textTransform:'none', 
                                        borderRadius:'8px',
                                        marginLeft:'auto'
                                    }}
                                > 
                                    <CSVLink
                                        data={filteredRowsTab5.length > 0 ? filteredRowsTab5.map(row => ({
                                            'Stop Name': row.Stop_Name || '--',
                                            'Pickup Tickets': row.Pickup_Tickets || '0',
                                            'Drop Tickets': row.Drop_Tickets || '0',
                                            'Total Tickets Sold': row.Total_Tickets_Sold || '0',
                                            'Morning Pickups': row.Morning_Pickups || '0',
                                            'Evening Pickups': row.Evening_Pickups || '0',
                                            'Morning Drops': row.Morning_Drops || '0',
                                            'Evening Drops': row.Evening_Drops || '0'
                                        })) : []}
                                        headers={[
                                            { label: 'Stop Name', key: 'Stop Name' },
                                            { label: 'Pickup Tickets', key: 'Pickup Tickets' },
                                            { label: 'Drop Tickets', key: 'Drop Tickets' },
                                            { label: 'Total Tickets Sold', key: 'Total Tickets Sold' },
                                            { label: 'Morning Pickups', key: 'Morning Pickups' },
                                            { label: 'Evening Pickups', key: 'Evening Pickups' },
                                            { label: 'Morning Drops', key: 'Morning Drops' },
                                            { label: 'Evening Drops', key: 'Evening Drops' }
                                        ]}
                                        filename={"Stop_Utilization_Report.csv"}
                                        style={{ 
                                            textDecoration: 'none',
                                            color: '#fff'
                                        }}
                                    > 
                                        <Typography sx={{color: '#fff', cursor: 'pointer'}}>Export CSV</Typography>
                                    </CSVLink>
                                </Button>
                            </Grid2>

                        </Grid2>

                        <TableContainer className="table-container" style={{maxHeight:'60vh'}}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel 
                                                className='table-header' 
                                                active={orderBy === 'booking_id'} 
                                                direction={orderBy === 'booking_id' ? order : 'asc'}
                                                onClick={() => handleRequestSort('booking_id')} 
                                                sx={{
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Stop Name
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            Pickup Tickets
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            Drop Tickets
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            Total Ticket sold
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Morning Pickups
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Evening Pickups
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Morning Drop
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Evening Drop
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {paginatedDataTab5.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={13} align="center">
                                                <Typography variant="body1">No data found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                    paginatedDataTab5.map((row) => {
                                        return (
                                            <TableRow key={row.session_id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.Stop_Name}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.Pickup_Tickets}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.Drop_Tickets}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.Total_Tickets_Sold}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.Morning_Pickups}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.Evening_Pickups}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.Morning_Drops}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.Evening_Drops}</Typography></TableCell>

                                            </TableRow>
                                        );
                                    })
                                )}
                                </TableBody>

                            </Table>

                            <div className="custom-pagination">
                                <div className="pagination-info">
                                    {`Showing ${pageTab5 * rowsPerPageTab5 + 1} to ${Math.min(
                                        (pageTab5 + 1) * rowsPerPageTab5,
                                        filteredRowsTab5.length
                                    )} of ${filteredRowsTab5.length} entries`}
                                </div>
                                <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePageTab5(null, pageTab5 - 1)}
                                    disabled={pageTab5 === 0}
                                    className="pagination-arrow"    
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                                
                                    <div className="pagination-numbers">
                                        {pageTab5 > 1 && (
                                            <>
                                                <button onClick={() => handleChangePageTab5(null, 0)} className="pagination-number">
                                                    1
                                                </button>
                                                <span className="pagination-dots">...</span>
                                            </>
                                        )}
                                        {[...Array(Math.ceil(filteredRowsTab5.length / rowsPerPageTab5))]
                                            .map((_, index) => index)
                                            .filter((index) => index >= pageTab5 - 1 && index <= pageTab5 + 1) // Show only previous, current, and next page
                                            .map((index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handleChangePageTab5(null, index)}
                                                    className={`pagination-number ${pageTab5 === index ? 'active' : ''}`}
                                                >
                                                    {index + 1}
                                                </button>
                                        ))}

                                        {pageTab5 < Math.ceil(filteredRowsTab5.length / rowsPerPageTab5) - 2 && (
                                            <>
                                                <span className="pagination-dots">...</span>
                                                <button
                                                    onClick={() => handleChangePageTab5(null, Math.ceil(filteredRowsTab5.length / rowsPerPageTab5) - 1)}
                                                    className="pagination-number"
                                                >
                                                    {Math.ceil(filteredRowsTab5.length / rowsPerPageTab5)}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleChangePageTab5(null, pageTab5 + 1)}
                                        disabled={pageTab5 >= Math.ceil(filteredRowsTab5.length / rowsPerPageTab5) - 1}
                                        className="pagination-arrow"
                                    >
                                        <img src={nextIcon} alt="Next" />
                                    </button>
                                </div>
                            </div>
                        </TableContainer>
                    </Paper>
                </TabPanel>

                <TabPanel value="6" style={{padding:' 0% 0%'}}>
                    <Paper elevation={2} style={{padding:'2%'}}>
                        <Grid2 item container spacing={2}>
                            <Grid2 item>
                                <Select value={cityFilterfortab6} 
                                onChange={(e) => handleCityChangefortab6(e.target.value)} displayEmpty
                                style={{width: '140px',height:'48px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                                    {clientRole == 1 && <MenuItem value="">Select City</MenuItem>}
                                    {cities.map((city) => (
                                        <MenuItem key={city.city_name} value={city.city_id}>
                                            {city.city_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>

                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                        '& .MuiInputBase-root': {
                                            minHeight: '48px',
                                            height: '48px',
                                            borderRadius: '8px',
                                            backgroundColor: '#FFFFFF',
                                        }
                                    }}
                                    value={startdatetab6}
                                    onChange={(newValue) => {
                                    if (enddatetab6 && newValue && newValue.isAfter(enddatetab6)) {
                                        setEnddatetab6(null);
                                    }
                                    setStartdatetab6(newValue);
                                    }}
                                    maxDate={enddatetab6 || undefined}
                                    />
                                </LocalizationProvider>
                            </Grid2>

                            <Grid2 item xs="auto" sx={{ display: 'flex', alignItems: 'center' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                    slotProps={{ textField: { size: 'small' } }}
                                    sx={{
                                        width: 'auto',
                                    '& .MuiInputBase-root': {
                                        minHeight: '48px', // or your desired height
                                        height: '48px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        alignItems: 'center',
                                    },
                                    '& input': {
                                        padding: '24px 14px', // increase vertical padding as needed   // optional: increase font size
                                    },
                                    }}
                                    value={enddatetab6}
                                    onChange={(newValue) => {
                                        setEnddatetab6(newValue)
                                    }}
                                    // minDate={startdatetab6 || undefined}
                                    // maxDate={endDateFilter}
                                    />
                                </LocalizationProvider>
                            </Grid2>

                            {/* <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="text"  // Changed from number to text to have more control
                                    placeholder="Trip Id" 
                                    className="filterBtn"
                                    value={tripIdTab6} 
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '');
                                        setTripIdTab6(value);
                                    }}
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    style={{ 
                                        width: '80%',
                                        height: '48px',
                                        borderRadius: '8px',
                                        padding: '0 12px',
                                        border: '1px solid #ccc',
                                        fontSize: '14px'
                                    }}
                                />
                            </Grid2> */}
                            <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="text"  // Changed from number to text to have more control
                                    placeholder="Route Id" 
                                    className="filterBtn"
                                    value={routeIdTab6} 
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '');
                                        setrouteIdTab6(value);
                                    }}
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    style={{ 
                                        width: '80%',
                                        height: '48px',
                                        borderRadius: '8px',
                                        padding: '0 12px',
                                        border: '1px solid #ccc',
                                        fontSize: '14px'
                                    }}
                                />
                            </Grid2>
                         <Grid2 item xs="auto" sx={{ width: '150px', height: '50px' }}>
                                <input 
                                    type="text"  // Changed from number to text to have more control
                                    placeholder="Pass Id" 
                                    className="filterBtn"
                                    value={passIdTab6} 
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, '');
                                        setPassIdTab6(value);
                                    }}
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    style={{ 
                                        width: '80%',
                                        height: '48px',
                                        borderRadius: '8px',
                                        padding: '0 12px',
                                        border: '1px solid #ccc',
                                        fontSize: '14px'
                                    }}
                                />
                            </Grid2>

                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button 
                                    variant='contained' 
                                    style={{
                                        width: '120px', 
                                        height: '48px', 
                                        backgroundColor:'#36C68F', 
                                        textTransform:'none', 
                                        borderRadius:'8px',
                                        marginLeft:'auto'
                                    }}
                                > 
                                        <CSVLink
                                            data={(() => {
                                                // Create a map for quick lookups
                                                const routeMap = {};
                                                data.route_mapping?.forEach(r => {
                                                    if (!routeMap[r.pass_id]) routeMap[r.pass_id] = [];
                                                    routeMap[r.pass_id].push(`${r.route_id} (${r.route_name})`);
                                                });

                                                const boardingMap = {};
                                                data.stop_boarding?.forEach(s => {
                                                    if (!boardingMap[s.pass_id]) boardingMap[s.pass_id] = [];
                                                    boardingMap[s.pass_id].push(`${s.stop_id} (${s.stop_name}): ${s.boarding_count}`);
                                                });

                                                const deboardingMap = {};
                                                data.stop_deboarding?.forEach(s => {
                                                    if (!deboardingMap[s.pass_id]) deboardingMap[s.pass_id] = [];
                                                    deboardingMap[s.pass_id].push(`${s.stop_id} (${s.stop_name}): ${s.deboarding_count}`);
                                                });

                                                // Create single table with pass summary and related data
                                                return data.pass_summary?.map(row => ({
                                                    "Pass Id": row.pass_id ?? "--",
                                                    "Pass Name": row.pass_name ?? "--",
                                                    "Pass Type": row.pass_type ?? "--",
                                                    "Status": row.status ?? "--",
                                                    "Morning Rides": row.morning_rides ?? "--",
                                                    "Evening Rides": row.evening_rides ?? "--",
                                                    "Total Rides": row.total_rides ?? "--",
                                                    "Discount Percentage": row.discount_percentage ?? "--",
                                                    "Validity Days": row.validity_days ?? "--",
                                                    "Total Pass Limit": row.total_pass_limit ?? "--",
                                                    "Per User Pass Limit": row.per_user_pass_limit ?? "--",
                                                    "Per User Cancellation Limit": row.per_user_cancellation_limit ?? "--",
                                                    "Subscriptions Sold": row.subscriptions_sold ?? "--",
                                                    "Unique Users": row.unique_users ?? "--",
                                                    "Total Morning Allocated": row.total_morning_allocated ?? "--",
                                                    "Total Evening Allocated": row.total_evening_allocated ?? "--",
                                                    "Total Ride Allocated": row.total_rides_allocated ?? "--",
                                                    "Morning Used": row.morning_used ?? "--",
                                                    "Evening Used": row.evening_used ?? "--",
                                                    "Total Used": row.rides_used ?? "--",
                                                    "Eligible From": dayjs(row.eligible_from).format('YYYY-MM-DD') ?? "--",
                                                    "Eligible To": dayjs(row.eligible_to).format('YYYY-MM-DD') ?? "--",
                                                    "Remaining Rides": row.remaining_rides ?? "--",
                                                    "Total Seat Booked": row.total_seats_booked ?? "--",
                                                    "Canceled Seat Count": row.cancellation_seat_count ?? "--",
                                                    "Total Amount Collected": row.total_amount_collected ?? "--",
                                                    "Total Amount Refunded": row.total_amount_refunded ?? "--",
                                                    "Reschedule Count": row.reschedule_count ?? "--",
                                                    "Route Mappings": routeMap[row.pass_id]?.join("; ") ?? "--",
                                                    "Stop Boarding": boardingMap[row.pass_id]?.join("; ") ?? "--",
                                                    "Stop Deboarding": deboardingMap[row.pass_id]?.join("; ") ?? "--",
                                                    "Renew Count": row.renew ?? "--",

                                                })) || [];
                                            })()}
                                            filename="Shuttle_Pass_Report_Tab6.csv"
                                            style={{
                                                textDecoration: "none",
                                                color: "#fff",
                                            }}
                                        >
                                            <Typography sx={{ color: "#fff", cursor: "pointer" }}>
                                                Export CSV
                                            </Typography>
                                        </CSVLink>
                                </Button>
                            </Grid2>

                        </Grid2>

                        <TableContainer className="table-container" style={{maxHeight:'60vh'}}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel 
                                                className='table-header' 
                                                active={orderBy === 'pass_id'} 
                                                direction={orderBy === 'pass_id' ? order : 'asc'}
                                                onClick={() => handleRequestSort('pass_id')} 
                                                sx={{
                                                    justifyContent:'center',
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Pass Id
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header">
                                            <TableSortLabel 
                                                className='table-header' 
                                                sx={{
                                                    minWidth:'300px',
                                                    justifyContent:'center',
                                                    '& .MuiTableSortLabel-icon': {
                                                        color: '#0065FF !important', // Change the arrow color
                                                    },
                                                }}>
                                                Pass Name
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header">Route Id</TableCell>
                                         <TableCell align="center" className="table-header">Route Name</TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            Pass Type
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            Status
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '15%' }}>
                                            Morning Rides
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Evening Rides
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Rides
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Discount Percentage
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Validity Days
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Pass Limit
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Per User Pass Limit
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Per User Cancelation Limit
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Subscriptions Sold
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Unique Users
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Morning Allocated
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Evening Allocated
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Ride Allocated
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Morning Used
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Evening Used
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Used
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Elligible From
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Elligible To
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Remaining Rides
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Seat Booked
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Cancellation Seat Count
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Amount Collected
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Total Amount Refunded
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Reschedule Count
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>
                                            Renew Count
                                        </TableCell>

                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {paginatedDataTab6.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={13} align="center">
                                                <Typography variant="body1">No data found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                    paginatedDataTab6.map((row) => {
                                        return (
                                            <TableRow key={row.session_id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.pass_id || '--'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.pass_name || '--'}</Typography></TableCell>
                                                <TableCell align="center">
                                                <Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>
                                                        {row.route_id || '--'}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>
                                                        {row.route_name || '--'}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.pass_type || '--'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.status || '--'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.morning_rides !== undefined && row.morning_rides !== null ? row.morning_rides: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.evening_rides !== undefined && row.evening_rides !== null ? row.evening_rides: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.total_rides !== undefined && row.total_rides !== null ? row.total_rides: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.discount_percentage !== undefined && row.discount_percentage !== null ? row.discount_percentage: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.validity_days !== undefined && row.validity_days !== null ? row.validity_days: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.total_pass_limit !== undefined && row.total_pass_limit !== null ? row.total_pass_limit: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.per_user_pass_limit !== undefined && row.per_user_pass_limit !== null ? row.per_user_pass_limit: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.per_user_cancellation_limit !== undefined && row.per_user_cancellation_limit !== null ? row.per_user_cancellation_limit: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.subscriptions_sold !== undefined && row.subscriptions_sold !== null ? row.subscriptions_sold: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.unique_users !== undefined && row.unique_users !== null ? row.unique_users: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.total_morning_allocated !== undefined && row.total_morning_allocated !== null ? row.total_morning_allocated: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.total_evening_allocated !== undefined && row.total_evening_allocated !== null ? row.total_evening_allocated: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.total_rides_allocated !== undefined && row.total_rides_allocated !== null ? row.total_rides_allocated: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.morning_used !== undefined && row.morning_used !== null ? row.morning_used: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.evening_used !== undefined && row.evening_used !== null ? row.evening_used: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.rides_used !== undefined && row.rides_used !== null ? row.rides_used: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.eligible_from ? dayjs(row.eligible_from).format('YYYY-MM-DD') : '--'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.eligible_to ? dayjs(row.eligible_to).format('YYYY-MM-DD') : '--'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.remaining_rides !== undefined && row.remaining_rides !== null ? row.remaining_rides: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.total_seats_booked !== undefined && row.total_seats_booked !== null ? row.total_seats_booked: '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.cancellation_seat_count !== undefined && row.cancellation_seat_count !== null ? row.cancellation_seat_count : '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.total_amount_collected !== undefined && row.total_amount_collected !== null ? row.total_amount_collected : '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.total_amount_refunded !== undefined && row.total_amount_refunded !== null ? row.total_amount_refunded : '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.reschedule_count !== undefined && row.reschedule_count !== null ? row.reschedule_count : '0'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', marginRight:'18px' }}>{row.renew_count !== undefined && row.renew_count !== null ? row.renew_count : '0'}</Typography></TableCell>
 
                                            </TableRow>
                                        );
                                    })
                                )}
                                </TableBody>

                            </Table>

                            <div className="custom-pagination">
                                <div className="pagination-info">
                                    {`Showing ${pageTab6 * rowsPerPageTab6 + 1} to ${Math.min(
                                        (pageTab6 + 1) * rowsPerPageTab6,
                                        filteredRowsTab6.length
                                    )} of ${filteredRowsTab6.length} entries`}
                                </div>
                                <div className="pagination-controls">
                                <button
                                    onClick={() => handleChangePageTab6(null, pageTab6 - 1)}
                                    disabled={pageTab6 === 0}
                                    className="pagination-arrow"    
                                >
                                    <img src={prevIcon} alt="Previous" />
                                </button>
                                
                                    <div className="pagination-numbers">
                                        {pageTab6 > 1 && (
                                            <>
                                                <button onClick={() => handleChangePageTab6(null, 0)} className="pagination-number">
                                                    1
                                                </button>
                                                <span className="pagination-dots">...</span>
                                            </>
                                        )}
                                        {[...Array(Math.ceil(filteredRowsTab6.length / rowsPerPageTab6))]
                                            .map((_, index) => index)
                                            .filter((index) => index >= pageTab6 - 1 && index <= pageTab6 + 1) // Show only previous, current, and next page
                                            .map((index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handleChangePageTab6(null, index)}
                                                    className={`pagination-number ${pageTab6 === index ? 'active' : ''}`}
                                                >
                                                    {index + 1}
                                                </button>
                                        ))}

                                        {pageTab6 < Math.ceil(filteredRowsTab6.length / rowsPerPageTab6) - 2 && (
                                            <>
                                                <span className="pagination-dots">...</span>
                                                <button
                                                    onClick={() => handleChangePageTab6(null, Math.ceil(filteredRowsTab6.length / rowsPerPageTab6) - 1)}
                                                    className="pagination-number"
                                                >
                                                    {Math.ceil(filteredRowsTab6.length / rowsPerPageTab6)}
                                                </button>
                                            </>
                                        )}
                                    </div>
                                    <button
                                        onClick={() => handleChangePageTab6(null, pageTab6 + 1)}
                                        disabled={pageTab6 >= Math.ceil(filteredRowsTab6.length / rowsPerPageTab6) - 1}
                                        className="pagination-arrow"
                                    >
                                        <img src={nextIcon} alt="Next" />
                                    </button>
                                </div>
                            </div>
                        </TableContainer>
                    </Paper>
                </TabPanel>
            </TabContext>
            )}

            <Dialog open={openRefundModal} onClose={handleCloseRefundModal} fullWidth maxWidth="xs">
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Refund Booking #{selectedRefundBooking?.booking_id}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Are you sure you want to initiate a refund for this booking
                        {selectedRefundBooking?.user_name ? ` by ${selectedRefundBooking.user_name}` : ''}?
                    </DialogContentText>
                    <TextField
                        autoFocus
                        fullWidth
                        required
                        multiline
                        minRows={3}
                        label="Refund reason"
                        placeholder="e.g. customer requested card refund"
                        value={refundReason}
                        onChange={(e) => { setRefundReason(e.target.value); setRefundError(''); }}
                        error={!!refundError && !refundReason.trim()}
                        helperText={!!refundError && !refundReason.trim() ? 'Reason is required' : ' '}
                        disabled={refundSubmitting}
                    />
                    {refundError && <Alert severity="error" sx={{ mt: 1 }}>{refundError}</Alert>}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button
                        onClick={handleCloseRefundModal}
                        disabled={refundSubmitting}
                        sx={{ textTransform: 'none', color: '#000', border: '1px solid #000', borderRadius: '8px', px: 3 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirmRefund}
                        disabled={refundSubmitting || !refundReason.trim()}
                        sx={{ textTransform: 'none', bgcolor: '#0065FF', boxShadow: 'none', borderRadius: '8px', px: 3, minWidth: '120px' }}
                    >
                        {refundSubmitting ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Confirm Refund'}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default ShuttleBooking;